{
  "account.account": "Perfil y seguridad",
  "account.accountDeleted": "Tu cuenta ha sido eliminada.",
  "account.accountDescription": "Nombre, contraseña, eliminar la cuenta",
  "account.accountSection": "Cuenta",
  "account.changeEmail": "Cambiar correo electrónico",
  "account.changePassword": "Cambiar contraseña",
  "account.currentPassword": "Contraseña actual",
  "account.dangerZone": "Zona de riesgo",
  "account.deleteAccount": "Eliminar tu cuenta",
  "account.deleteAccountConfirmation": "¿Estás seguro de que deseas eliminar tu cuenta? ¡No puedes deshacer si eliminas tu cuenta!",
  "account.deleteAccountDescription": "Esta acción elimina tu cuenta y toda tu información. No hay vuelta atrás.",
  "account.emailChange": "Cambiar dirección de correo electrónico",
  "account.emailChangeConfirmation": "Confirmación de cambio de correo electrónico",
  "account.emailChangeFailure": "El enlace de cambio de correo electrónico es inválido o ha expirado.",
  "account.emailChangeIntro": "Introduce tu nueva dirección de correo electrónico y tu contraseña actual. Enviaremos un enlace a la nueva dirección: tu correo solo cambiará cuando lo abras.",
  "account.emailChangeSuccess": "Tu correo electrónico ha sido cambiado exitosamente a {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Tu dirección de correo electrónico se ha cambiado correctamente.",
  "account.emailChangeVerificationSent": "Se ha enviado un correo de verificación a tu nueva dirección de correo electrónico. Por favor, revisa tu bandeja de entrada y haz clic en el enlace para confirmar el cambio.",
  "account.manageAccount": "Administrar cuenta",
  "account.newEmailAddress": "Nueva dirección de correo electrónico",
  "account.newPassword": "Nueva contraseña",
  "account.newPasswordAgain": "Nueva contraseña (de nuevo)",
  "account.oldPassword": "Contraseña antigua",
  "account.passwordChange": "Cambio de contraseña",
  "account.passwordChangeDescription": "Mantén tu cuenta segura",
  "account.passwordUpdated": "Contraseña actualizada correctamente.",
  "account.profile": "Perfil",
  "account.profileUpdated": "Perfil actualizado correctamente.",
  "account.signedInAs": "Sesión iniciada como",
  "account.updateYourProfile": "Actualiza tu perfil",
  "account.updateYourProfileDescription": "Nombre y preferencias de visualización",
  "addons.accountOnHold": "La conexión de tu cuenta ha expirado. Vuelve a conectarte para reanudar las actualizaciones de datos.",
  "addons.accountOnHoldTitle": "Cuenta en pausa",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Genera y obtén la clave API desde este enlace",
  "addons.ambientWeatherDescription": "Estaciones meteorológicas Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Clave API",
  "addons.applicationKey": "Clave de programa",
  "addons.availableServices": "Disponibles",
  "addons.cannotDisconnectLastAccount": "No se puede desconectar tu único método de inicio de sesión. Por favor, añade primero otro método de inicio de sesión.",
  "addons.connect": "Conectar",
  "addons.connected": "Conectado",
  "addons.connectedAccounts": "Cuentas conectadas",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Cargando tus cuentas conectadas…",
  "addons.connectedServices": "Conectados",
  "addons.connectedSince": "Conectado desde {date}",
  "addons.connectionSection": "Conexión",
  "addons.connectionSuccess": "Cuenta de {provider} conectada correctamente",
  "addons.davisApiSecret": "Secreto de la API",
  "addons.davisApiV2Key": "Clave API V2",
  "addons.davisDescription": "Estaciones meteorológicas Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Obtén la clave API V2 de este enlace",
  "addons.disconnect": "Desconectar",
  "addons.disconnectConfirmation": "¿Estás seguro de que deseas desconectar tu cuenta de {provider}?",
  "addons.disconnectEnergyConfirmation": "SmartMixin dejará de sincronizar Netatmo Energy y quitará tus casas de SmartMixin. Tu cuenta de Netatmo y tus dispositivos no se verán afectados.",
  "addons.disconnectEnergyDescription": "Detiene la sincronización y quita tus casas de SmartMixin.",
  "addons.disconnectionSuccess": "Cuenta de {provider} desconectada correctamente",
  "addons.disconnectProviderDescription": "Detiene la sincronización y elimina las estaciones de este servicio y su historial.",
  "addons.disconnectServiceConfirmation": "SmartMixin dejará de sincronizar {provider} y eliminará las estaciones de este servicio y todo su historial. Tu cuenta de {provider} no se verá afectada.",
  "addons.disconnectServiceTitle": "¿Desconectar {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Genera y recupera una clave API y una clave de aplicación desde este enlace",
  "addons.ecowittDescription": "Ecowitt ofrece estación meteorológica wifi profesional, termómetros inalámbricos para interior y exterior, medidor de humedad, pluviómetro de alta precisión, medidor de calidad del aire, etc.",
  "addons.helpLink": "Cómo conectar {provider}",
  "addons.integrationsSection": "Integraciones",
  "addons.myAcuriteAccountOnHold": "Tu cuenta ha sido suspendida. Por favor ingresa tu contraseña para volver a conectar tu cuenta",
  "addons.myAcuriteDescription": "AcuRite es la marca de estaciones meteorológicas número uno en Norteamérica. Como líder en tecnología de tiempo, temperatura y clima, AcuRite te proporciona información detallada sobre tu entorno interior y exterior para que puedas planificar tu día con confianza.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Usa tu Termostato Netatmo para cambiar la temperatura de tu hogar, desde tu cama o desde el otro lado del mundo.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Tu estación meteorológica personal en casa",
  "addons.notConnected": "No conectado",
  "addons.or": "o",
  "addons.providerAccountDisconnected": "La conexión con tu servicio meteorológico ha expirado. Vuelve a conectarte para reanudar las actualizaciones de datos.",
  "addons.reconnect": "Reconectar",
  "addons.socialConnectionsIntro": "Vincula tus cuentas sociales para iniciar sesión rápidamente. Puedes conectar o desconectar cuentas en cualquier momento.",
  "addons.weatherflowAccessToken": "Token de acceso",
  "addons.weatherflowCreateToken": "Crea y obtén tu token desde este enlace",
  "addons.weatherflowTempestDescription": "Sistema meteorológico Tempest con anemómetro y pluviómetro integrados",
  "addons.weatherServices": "Servicios meteorológicos",
  "addons.weatherServicesConnected": "{count, plural, =0 {Ningún servicio conectado} one {# servicio conectado} other {# servicios conectados}}",
  "addons.weatherServicesDescription": "Conecta Netatmo, Davis, Weatherflow y más",
  "addons.wundergroundApiKey": "Clave API",
  "addons.wundergroundDescription": "Weather Underground es una comunidad global de personas que conectan datos de sensores ambientales como estaciones meteorológicas y monitores de calidad del aire, por lo que podemos proporcionar los datos hiperlocales que necesitas para ejecutar tus pasatiempos.",
  "addons.wundergroundRemoveStationDescription": "La estación sale de tu cuenta de SmartMixin. Salvo que otra cuenta de SmartMixin también la haya agregado, se borran la estación y el historial que SmartMixin registró para ella. En Weather Underground no cambia nada.",
  "addons.wundergroundRemoveStationTitle": "¿Borrar {station}?",
  "addons.wundergroundRetrieveApiKey": "Obtén tu clave API usando este enlace",
  "addons.wundergroundStationId": "Identificación de la estación",
  "airQuality.adviceActivityGood": "Un día ideal para actividades al aire libre",
  "airQuality.adviceActivityHazardous": "Evita toda actividad física al aire libre",
  "airQuality.adviceActivityLabel": "Actividad física",
  "airQuality.adviceActivityModerate": "Un buen día para actividades al aire libre",
  "airQuality.adviceActivitySensitive": "Considera actividades al aire libre más cortas y menos intensas",
  "airQuality.adviceActivityUnhealthy": "Reduce las actividades largas o intensas y haz más pausas",
  "airQuality.adviceActivityVeryUnhealthy": "Evita las actividades largas o intensas; considera trasladarlas al interior",
  "airQuality.adviceGroupsGood": "No se necesitan precauciones especiales",
  "airQuality.adviceGroupsHazardous": "Permanece en el interior y limita la actividad",
  "airQuality.adviceGroupsLabel": "Grupos sensibles",
  "airQuality.adviceGroupsModerate": "Personas especialmente sensibles: actividades más cortas y menos intensas",
  "airQuality.adviceGroupsSensitive": "Haz actividades al aire libre más cortas y menos intensas, y más pausas",
  "airQuality.adviceGroupsUnhealthy": "Evita las actividades largas o intensas al aire libre; considera trasladarlas al interior",
  "airQuality.adviceGroupsVeryUnhealthy": "Evita toda actividad física al aire libre; aplázala o trasládala al interior",
  "airQuality.adviceTimingLabel": "Cuándo salir",
  "airQuality.adviceTimingMorning": "Mejor por la mañana: el ozono es más bajo",
  "airQuality.airQuality": "Calidad del aire",
  "airQuality.airQualityIndex": "Índice de calidad del aire",
  "airQuality.aqiForecast": "Pronóstico de calidad del aire",
  "airQuality.co2Fresh": "Fresco",
  "airQuality.co2GettingStale": "Algo cargado",
  "airQuality.co2Stale": "Cargado",
  "airQuality.dailyForecast": "Pronóstico diario",
  "airQuality.dominantPollutant": "Contaminante dominante",
  "airQuality.expectedPeak": "Pico previsto",
  "airQuality.good": "Buena",
  "airQuality.goodDescription": "No se anticipan impactos a la salud cuando la calidad del aire se encuentra en este intervalo.",
  "airQuality.hazardous": "Peligrosa",
  "airQuality.hazardousDescription": "Advertencia de salud: todos pueden experimentar efectos de salud más graves",
  "airQuality.indoorAirQuality": "Calidad del aire interior",
  "airQuality.moderate": "Moderada",
  "airQuality.moderateDescription": "La calidad del aire es aceptable; sin embargo, algunos contaminantes pueden suponer un riesgo moderado para la salud de un número muy reducido de personas inusualmente sensibles a la contaminación del aire.",
  "airQuality.noForecastForLocation": "No hay pronóstico de calidad del aire disponible para esta ubicación.",
  "airQuality.now": "Ahora",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Contaminantes",
  "airQuality.recommendations": "Recomendaciones",
  "airQuality.sensitiveUnhealthy": "Dañina a la salud para grupos sensibles",
  "airQuality.sensitiveUnhealthyDescription": "Los miembros de grupos sensibles pueden sufrir efectos en la salud. Es poco probable que el público en general se vea afectado.",
  "airQuality.subIndex": "Subíndice AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Entender el índice",
  "airQuality.unhealthy": "Dañina a la salud",
  "airQuality.unhealthyDescription": "Todos pueden empezar a sufrir efectos en la salud; los miembros de grupos sensibles pueden sufrir efectos más graves.",
  "airQuality.veryUnhealthy": "Muy dañina a la salud",
  "airQuality.veryUnhealthyDescription": "Advertencias sanitarias de condiciones de emergencia. Es más probable que toda la población se vea afectada.",
  "alerts.addAlert": "Agregar alerta",
  "alerts.addCondition": "Agregar condición",
  "alerts.alertAdded": "Se ha añadido la alerta.",
  "alerts.alertAuthorizationNotice": "Las alertas solo funcionan si autorizas a SmartMixin a mostrar notificaciones",
  "alerts.alertDeleted": "La alerta fue eliminada",
  "alerts.alertName": "Nombre de alerta",
  "alerts.alertWhen": "Seré notificado cuando:",
  "alerts.aqiGreaterThan": "ICA superior a",
  "alerts.aqiGreaterThanThreshold": "AQI superior al límite de {value}{unit}",
  "alerts.aqiLessThan": "ICA inferior a",
  "alerts.aqiLessThanThreshold": "AQI inferior al límite de {value}{unit}",
  "alerts.atLeastOneCondition": "Debes agregar al menos una condición",
  "alerts.co2GreaterThan": "CO2 superior a",
  "alerts.co2GreaterThanThreshold": "CO2 superior al límite de {value}{unit}",
  "alerts.co2LessThan": "CO2 inferior a",
  "alerts.co2LessThanThreshold": "CO2 inferior al límite de {value}{unit}",
  "alerts.conditions": "Condiciones",
  "alerts.conditionsDroppedOnStationChange": "No compatibles con esta estación y eliminadas: {conditions}",
  "alerts.createAlert": "Crear alerta",
  "alerts.dailyPrecipitationGreaterThan": "Precipitación diaria superior a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitación diaria superior al umbral de {value}{unit}",
  "alerts.deleteAlert": "Eliminar alerta",
  "alerts.editAlert": "Editar alerta",
  "alerts.editCondition": "Editar condición",
  "alerts.gustSpeedGreaterThan": "Ráfaga más alta que",
  "alerts.gustSpeedGreaterThanThreshold": "Ráfaga de viento superior al límite de {value}{unit}",
  "alerts.gustSpeedLessThan": "Ráfaga más baja que",
  "alerts.gustSpeedLessThanThreshold": "Ráfaga de viento inferior al límite de {value}{unit}",
  "alerts.heatIndexGreaterThan": "Índice de calor superior a",
  "alerts.heatIndexGreaterThanThreshold": "Índice de calor superior al límite de {value}{unit}",
  "alerts.heatIndexLessThan": "Índice de calor inferior a",
  "alerts.heatIndexLessThanThreshold": "Índice de calor inferior al límite de {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex superior a",
  "alerts.humidexGreaterThanThreshold": "Humidex superior al límite de {value}{unit}",
  "alerts.humidexLessThan": "Humidex inferior a",
  "alerts.humidexLessThanThreshold": "Humidex inferior al límite de {value}{unit}",
  "alerts.humidityGreaterThan": "Humedad superior a",
  "alerts.humidityGreaterThanThreshold": "Humedad superior al límite de {value}{unit}",
  "alerts.humidityLessThan": "Humedad inferior a",
  "alerts.humidityLessThanThreshold": "Humedad inferior al límite de {value}{unit}",
  "alerts.inProgress": "En curso",
  "alerts.leafWetnessGreaterThan": "Humedad de la hoja superior a",
  "alerts.leafWetnessGreaterThanThreshold": "Humedad de la hoja superior al límite de {value}{unit}",
  "alerts.leafWetnessLessThan": "Humedad de la hoja inferior a",
  "alerts.leafWetnessLessThanThreshold": "Humedad de la hoja inferior al límite de {value}{unit}",
  "alerts.myAlerts": "Mis Alertas",
  "alerts.noConfiguredAlert": "Aún no has configurado ninguna alerta, empieza por añadir una",
  "alerts.noiseGreaterThan": "Ruido más fuerte que",
  "alerts.noiseGreaterThanThreshold": "Ruido superior al límite de {value}{unit}",
  "alerts.noiseLessThan": "Ruido inferior a",
  "alerts.noiseLessThanThreshold": "Ruido inferior al límite de {value}{unit}",
  "alerts.noteOnConditions": "Ten en cuenta que la alerta se activa cuando se confirman todas las condiciones a continuación",
  "alerts.noTriggerHistory": "Esta alerta aún no se ha activado.",
  "alerts.pm10GreaterThan": "PM 10 más alto que",
  "alerts.pm10GreaterThanThreshold": "PM 10 superior al límite de {value}{unit}",
  "alerts.pm10LessThan": "PM 10 más bajo que",
  "alerts.pm10LessThanThreshold": "PM 10 por debajo del límite de {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 más alto que",
  "alerts.pm1GreaterThanThreshold": "PM 1 superior al límite de {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inferior a",
  "alerts.pm1LessThanThreshold": "PM 1 inferior al límite de {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 más alto que",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 más alto que el límite de {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 más bajo que",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 por debajo del límite de {value}{unit}",
  "alerts.postStormSummary": "Resumen de la tormenta",
  "alerts.postStormSynopsisHelper": "Recibirás una notificación de resumen al final de cada tormenta de lluvia.",
  "alerts.postStormSynopsisSoleCondition": "Un resumen posterior a la tormenta no se puede combinar con otras condiciones.",
  "alerts.precipitationGreaterThan": "Precipitación horaria superior a",
  "alerts.precipitationGreaterThanThreshold": "Precipitación horaria superior al umbral de {value}{unit}",
  "alerts.pressureGreaterThan": "Presión de aire superior a",
  "alerts.pressureGreaterThanThreshold": "Presión de aire superior al límite de {value}{unit}",
  "alerts.pressureLessThan": "Presión de aire inferior a",
  "alerts.pressureLessThanThreshold": "Presión de aire inferior al límite de {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensidad de lluvia superior a",
  "alerts.rainRateGreaterThanThreshold": "Intensidad de lluvia superior al umbral de {value}{unit}",
  "alerts.sensorNotReporting": "Este sensor no está enviando datos ahora mismo. La alerta se reanudará cuando vuelva a hacerlo.",
  "alerts.soilMoistureGreaterThan": "Humedad del suelo superior a",
  "alerts.soilMoistureGreaterThanThreshold": "Humedad del suelo superior al límite de {value}{unit}",
  "alerts.soilMoistureLessThan": "Humedad del suelo inferior a",
  "alerts.soilMoistureLessThanThreshold": "Humedad del suelo inferior al límite de {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiación solar superior a",
  "alerts.solarRadiationGreaterThanThreshold": "Radiación solar superior al límite de {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiación solar inferior a",
  "alerts.solarRadiationLessThanThreshold": "Radiación solar inferior al límite de {value}{unit}",
  "alerts.stationNoLongerReports": "Esta estación ya no envía datos, así que esta alerta no puede activarse.",
  "alerts.stormChartUnavailable": "El historial de lluvia de esta tormenta no está disponible.",
  "alerts.stormDetail": "Resumen de la tormenta",
  "alerts.stormDuration": "Duración",
  "alerts.stormEnd": "Fin",
  "alerts.stormPeakRate": "Intensidad máxima de lluvia",
  "alerts.stormStart": "Inicio",
  "alerts.stormTotal": "Lluvia total",
  "alerts.temperatureGreaterThan": "Temperatura superior a",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superior al límite de {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura inferior a",
  "alerts.temperatureLessThanThreshold": "Temperatura inferior al límite de {value}{unit}",
  "alerts.thresholdOutOfRange": "Debe estar entre {min} y {max}",
  "alerts.thswGreaterThan": "THSW superior a",
  "alerts.thswGreaterThanThreshold": "THSW superior al límite de {value}{unit}",
  "alerts.thswLessThan": "THSW inferior a",
  "alerts.thswLessThanThreshold": "THSW inferior al límite de {value}{unit}",
  "alerts.thwGreaterThan": "THW superior a",
  "alerts.thwGreaterThanThreshold": "THW superior al límite de {value}{unit}",
  "alerts.thwLessThan": "THW inferior a",
  "alerts.thwLessThanThreshold": "THW inferior al límite de {value}{unit}",
  "alerts.triggerHistory": "Historial de la alerta",
  "alerts.uvGreaterThan": "Índice UV superior a",
  "alerts.uvGreaterThanThreshold": "Índice UV superior al límite de {value}{unit}",
  "alerts.uvLessThan": "Índice UV inferior a",
  "alerts.uvLessThanThreshold": "Índice UV inferior al límite de {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilidad mayor que el límite de {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilidad menor que el límite de {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilidad mayor que",
  "alerts.visiblityLessThan": "Visibilidad menor que",
  "alerts.whichMeasure": "¿De qué medidas quieres que te avisemos?",
  "alerts.whichModule": "¿Para qué módulo te gustaría recibir alertas?",
  "alerts.whichSensor": "¿Para qué sensor te gustaría recibir alertas?",
  "alerts.windChillGreaterThan": "Enfriamiento por viento superior a",
  "alerts.windChillGreaterThanThreshold": "Enfriamiento por viento superior al límite de {value}{unit}",
  "alerts.windChillLessThan": "Enfriamiento por viento inferior a",
  "alerts.windChillLessThanThreshold": "Enfriamiento por viento inferior al límite de {value}{unit}",
  "alerts.windSpeedGreaterThan": "La velocidad del viento es superior a",
  "alerts.windSpeedGreaterThanThreshold": "La velocidad del viento es superior al límite de {value}{unit}",
  "alerts.windSpeedLessThan": "La velocidad del viento es inferior a",
  "alerts.windSpeedLessThanThreshold": "La velocidad del viento es inferior al límite de {value}{unit}",
  "appUpdate.updateAvailable": "Actualización disponible",
  "appUpdate.updateAvailableOpenAppStore": "Toca para abrir el App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Toca para abrir Google Play",
  "appUpdate.updateAvailableVersion": "Actualización disponible: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Se requiere una actualización de tu aplicación, ve a Google Play para actualizar.",
  "appUpdate.upgradeRequiredIos": "Se requiere una actualización de tu aplicación, ve a la App Store para actualizar.",
  "astral.aboveHorizonAllDay": "Sobre el horizonte todo el día",
  "astral.aboveTheHorizon": "sobre el horizonte",
  "astral.apparentSize": "Diámetro aparente",
  "astral.apparentSizeAcross": "{size} de diámetro",
  "astral.astronomicalDawn": "Alba astronómica",
  "astral.astronomicalDusk": "Crepúsculo astronómico",
  "astral.belowHorizonAllDay": "Bajo el horizonte todo el día",
  "astral.belowHorizonSince": "Bajo el horizonte desde las {time}",
  "astral.belowHorizonSinceOn": "Bajo el horizonte desde el {day} a las {time}",
  "astral.brightAllNight": "Luna brillante toda la noche — nunca totalmente oscuro",
  "astral.brightestMoment": "Momento más claro",
  "astral.civilDawn": "Alba civil",
  "astral.civilDusk": "Crepúsculo civil",
  "astral.darkSkyBetween": "Cielo oscuro {from} → {to}",
  "astral.darkSkyWindow": "Cielo oscuro {from} → {to} · {duration} sin Luna",
  "astral.dayLength": "Duración del día",
  "astral.daylightThroughTheYear": "Duración del día durante el año",
  "astral.dayOfCycle": "día {day} de {total}",
  "astral.doesNotOccurToday": "Hoy no ocurre",
  "astral.domeHint": "Arrastra para recorrer la noche",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Amanecer más temprano",
  "astral.earliestSunset": "Atardecer más temprano",
  "astral.equinox": "Equinoccio",
  "astral.equinoxIn": "Equinoccio en {days, plural, one {# día} other {# días}}",
  "astral.evening": "Tarde",
  "astral.exactPhaseAt": "Momento exacto: {time}",
  "astral.firstQuarter": "Cuarto creciente",
  "astral.firstSunriseIn": "Primera salida del sol en {days, plural, one {# día} other {# días}}",
  "astral.firstSunsetIn": "Primera puesta de sol en {days, plural, one {# día} other {# días}}",
  "astral.fullMoon": "Luna llena",
  "astral.goldenHourBegins": "Comienza la hora dorada",
  "astral.goldenHourEnds": "Termina la hora dorada",
  "astral.highestPoint": "Punto más alto",
  "astral.inDays": "en {days, plural, one {# día} other {# días}}",
  "astral.lastQuarter": "Cuarto menguante",
  "astral.latestSunrise": "Amanecer más tardío",
  "astral.latestSunset": "Atardecer más tardío",
  "astral.litShort": "Ilum.",
  "astral.longestDay": "Día más largo",
  "astral.lowestPoint": "Punto más bajo",
  "astral.maxAltitudeShort": "Máx.",
  "astral.midday": "Mediodía",
  "astral.midnightSun": "Sol de medianoche",
  "astral.midnightSunPeriod": "Sol de medianoche",
  "astral.milestoneFootnotePolar": "Aquí el sol no sale ni se pone durante {days, plural, one {# día} other {# días}} al año, así que, en lugar de los extremos habituales de salida y puesta, la lista muestra cuándo ocurre.",
  "astral.milestoneFootnoteTemperate": "La puesta más temprana y la salida más tardía no caen en el día más corto — es la ecuación del tiempo, no el solsticio, la que fija esas dos fechas.",
  "astral.moon": "Luna",
  "astral.moonAltitude": "Altura",
  "astral.moonDirection": "Acimut",
  "astral.moonDistance": "Distancia",
  "astral.moonlessFor": "{duration} sin Luna",
  "astral.moonPhases": "Fases de la Luna",
  "astral.moonrise": "Salida de la Luna",
  "astral.moonset": "Puesta de la Luna",
  "astral.moonUpAllNight": "La Luna está sobre el horizonte toda la noche",
  "astral.moonWashesOutNight": "La Luna está sobre el horizonte de {rise} a {set} e ilumina toda la noche",
  "astral.morning": "Mañana",
  "astral.nauticalDawn": "Alba náutica",
  "astral.nauticalDusk": "Crepúsculo náutico",
  "astral.newMoon": "Luna nueva",
  "astral.nextDay": "+1 día",
  "astral.nextProperlyDarkNight": "Próxima noche realmente oscura",
  "astral.nextRise": "próxima salida a las {time}",
  "astral.nextRiseOn": "próxima salida el {day} a las {time}",
  "astral.nextSevenNights": "Las próximas siete noches",
  "astral.nightDate": "Fecha",
  "astral.noAstronomicalDarknessTonight": "Sin noche astronómica esta noche",
  "astral.noDarkNightAhead": "Ninguna en las próximas dos semanas",
  "astral.noStationLocation": "Ubicación desconocida",
  "astral.noStationLocationDescription": "Esta estación no tiene ninguna posición registrada, por lo que no se pueden calcular el sol y la luna para ella.",
  "astral.noSunriseToday": "Hoy no amanece",
  "astral.nowAtBearing": "ahora {altitude} · acimut {direction}",
  "astral.observing": "Observación",
  "astral.ofDaylightLeft": "de luz restante",
  "astral.overTheNextThreeWeeks": "en las próximas 3 semanas",
  "astral.percentLit": "{percent} iluminada",
  "astral.polarNight": "Noche polar",
  "astral.polarNightPeriod": "Noche polar",
  "astral.rightNow": "Ahora mismo",
  "astral.riseShort": "Salida",
  "astral.setShort": "Puesta",
  "astral.shortestDay": "Día más corto",
  "astral.solarNoon": "Mediodía solar",
  "astral.solstice": "Solsticio",
  "astral.sunBelowHorizon": "Sol a {degrees}° bajo el horizonte",
  "astral.sunEvents": "Eventos solares",
  "astral.sunNeverDarkEnough": "El Sol nunca baja 18° por debajo del horizonte",
  "astral.sunNeverSets": "El Sol no se pone",
  "astral.sunrise": "Amanecer",
  "astral.sunriseAndSunset": "Amanecer y atardecer",
  "astral.sunriseAt": "Amanecer a las {time}",
  "astral.sunset": "Atardecer",
  "astral.sunsetAt": "Atardecer a las {time}",
  "astral.thisYearAtNorth": "Este año a {degrees}° N",
  "astral.thisYearAtSouth": "Este año a {degrees}° S",
  "astral.tonight": "Esta noche",
  "astral.twilightAllNight": "Crepúsculo toda la noche — nunca totalmente oscuro",
  "astral.upFor": "{duration} sobre el horizonte",
  "astral.usableLight": "Luz aprovechable",
  "astral.vsAverage": "{percent} respecto a la media",
  "astral.vsYesterday": "respecto a ayer",
  "astral.waningCrescent": "Luna menguante",
  "astral.waningGibbous": "Luna gibosa menguante",
  "astral.waxingCrescent": "Luna creciente",
  "astral.waxingGibbous": "Luna gibosa creciente",
  "astral.whereToLook": "Dónde mirar",
  "astral.withoutTheMoon": "{duration} sin Luna",
  "auth.alreadyHaveAccount": "¿Ya tienes una cuenta?",
  "auth.authContainerTagline": "Tu panel meteorológico personal. Conecta tus estaciones y obtén datos en tiempo real al alcance de tu mano.",
  "auth.backToLogin": "Volver al inicio de sesión",
  "auth.checkYourEmail": "Revisa tu correo electrónico",
  "auth.continueWithApple": "Continuar con Apple",
  "auth.continueWithFacebook": "Continuar con Facebook",
  "auth.continueWithGoogle": "Continuar con Google",
  "auth.email": "Dirección de correo electrónico",
  "auth.emailRequiredLoginFacebook": "Se necesita el correo electrónico para conectarse con Facebook",
  "auth.emailVerification": "Verificación del correo electrónico",
  "auth.emailVerificationFailure": "Hubo un problema con la verificación de tu correo electrónico.",
  "auth.emailVerificationSuccess": "Tu correo electrónico ha sido verificado.",
  "auth.firstName": "Nombre",
  "auth.forgotPassword": "Contraseña olvidada",
  "auth.forgotPasswordSubtitle": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
  "auth.lastName": "Apellido",
  "auth.login": "Iniciar sesión",
  "auth.loginSubtitle": "¡Bienvenido de nuevo! Por favor, ingresa tus datos.",
  "auth.loginToSmartMixinDescription": "Inicia sesión en SmartMixin para acceder a tus estaciones meteorológicas, ver análisis y gestionar tu panel meteorológico personal.",
  "auth.logout": "Cerrar sesión",
  "auth.logoutConfirmation": "¿Quieres cerrar la sesión?",
  "auth.noAccountYet": "¿No tienes una cuenta?",
  "auth.or": "o",
  "auth.password": "Contraseña",
  "auth.passwordReset": "Restablecer la contraseña",
  "auth.passwordResetSuccess": "Tu contraseña ha sido actualizada.",
  "auth.register": "Registrarse",
  "auth.registerDescription": "Crea una cuenta SmartMixin gratuita para conectar tus estaciones meteorológicas, seguir los datos del tiempo y acceder a potentes herramientas de análisis.",
  "auth.registerSubtitle": "Crea tu cuenta para comenzar.",
  "auth.restorePassword": "Restaurar contraseña",
  "auth.restorePasswordSuccess": "Acabamos de enviarte un enlace para restablecer la contraseña a {emailAddress} con más instrucciones.",
  "auth.sendReset": "Enviar instrucciones de restablecimiento",
  "auth.signInWithApple": "Iniciar sesión con Apple",
  "auth.socialAccount": "o usa tu cuenta",
  "auth.staffVerificationCode": "Código de verificación",
  "auth.staffVerificationExpiresIn": "Verificado. Caduca en {duration}.",
  "auth.staffVerificationInvalidCode": "Código incorrecto. Inténtalo de nuevo.",
  "auth.staffVerificationLoginAsStopped": "Se ha detenido Login As: introduce un código de verificación en la pantalla Debug para continuar.",
  "auth.staffVerificationNotEnrolled": "No hay ninguna aplicación de autenticación configurada en tu cuenta. Añade una en los ajustes de seguridad del back office.",
  "auth.staffVerificationPrompt": "Introduce el código de 6 dígitos de tu aplicación de autenticación, o un código de recuperación, para usar Login As y la búsqueda de usuarios.",
  "auth.staffVerificationSetupLink": "Añadir una aplicación de autenticación",
  "auth.staffVerificationSubmit": "Verificar",
  "auth.staffVerificationTitle": "Verificación del personal",
  "calendar.afternoon": "Tarde",
  "calendar.april": "Abril",
  "calendar.august": "Agosto",
  "calendar.changePeriod": "Periodo: {period}. Cambiar periodo",
  "calendar.currentDay": "Día actual",
  "calendar.dateFormat": "Formato de fecha",
  "calendar.day": "Día",
  "calendar.december": "Diciembre",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Años anteriores",
  "calendar.endTime": "Hora de finalización",
  "calendar.evening": "Noche",
  "calendar.february": "Febrero",
  "calendar.goToNextDay": "Día siguiente",
  "calendar.goToNextMonth": "Mes siguiente",
  "calendar.goToNextWeek": "Semana siguiente",
  "calendar.goToNextYear": "Año siguiente",
  "calendar.goToPreviousDay": "Día anterior",
  "calendar.goToPreviousMonth": "Mes anterior",
  "calendar.goToPreviousWeek": "Semana anterior",
  "calendar.goToPreviousYear": "Año anterior",
  "calendar.hour": "Hora",
  "calendar.hoursCount": "{count, plural, one {# hora} other {# horas}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} other {# h}}",
  "calendar.january": "Enero",
  "calendar.july": "Julio",
  "calendar.june": "Junio",
  "calendar.last12Hours": "Últimas 12 horas",
  "calendar.last24Hours": "Últimas 24 horas",
  "calendar.last30Days": "Últimos 30 días",
  "calendar.last3Hours": "Últimas 3 horas",
  "calendar.last6Hours": "Últimas 6 horas",
  "calendar.last7Days": "Últimos 7 días",
  "calendar.lastHour": "Última hora",
  "calendar.laterYears": "Años posteriores",
  "calendar.march": "Marzo",
  "calendar.max": "Máx",
  "calendar.may": "Mayo",
  "calendar.month": "Mes",
  "calendar.monthTotal": "Total del mes",
  "calendar.morning": "Mañana",
  "calendar.nextHours": "Próximas horas",
  "calendar.night": "Madrugada",
  "calendar.november": "Noviembre",
  "calendar.october": "Octubre",
  "calendar.oneDay": "1 día",
  "calendar.oneHour": "1 hora",
  "calendar.oneMonth": "1 mes",
  "calendar.oneWeek": "1 semana",
  "calendar.periodRangeSpoken": "del {start} al {end}",
  "calendar.previous24Hours": "24 horas anteriores",
  "calendar.previous30Days": "30 días anteriores",
  "calendar.previous7Days": "7 días anteriores",
  "calendar.previousDay": "El día anterior",
  "calendar.previousHours": "Horas anteriores",
  "calendar.previousMonth": "El mes anterior",
  "calendar.previousWeek": "La semana anterior",
  "calendar.previousYear": "El año anterior",
  "calendar.sameDayLastYear": "El mismo día del año pasado",
  "calendar.sameMonthLastYear": "El mismo mes del año pasado",
  "calendar.selectADate": "Selecciona una fecha",
  "calendar.selectAggregation": "Seleccionar el valor mostrado",
  "calendar.selectAMonth": "Selecciona un mes",
  "calendar.selectAYear": "Selecciona un año",
  "calendar.selectGranularity": "Seleccionar una granularidad",
  "calendar.selectPeriod": "Selecciona un periodo",
  "calendar.september": "Septiembre",
  "calendar.sixHours": "6 horas",
  "calendar.startTime": "Hora de inicio",
  "calendar.thirtyMinutes": "30 minutos",
  "calendar.threeHours": "3 horas",
  "calendar.timezone": "Huso horario",
  "calendar.today": "Hoy",
  "calendar.untilChanged": "Hasta que se modifique",
  "calendar.untilTime": "Hasta {time}",
  "calendar.untilTodayAt": "Hasta hoy a las {time}",
  "calendar.untilTomorrowAt": "Hasta mañana a las {time}",
  "calendar.use24HourFormat": "Usar el formato de 24 horas",
  "calendar.week": "Semana",
  "calendar.year": "Año",
  "calendar.yearToDate": "En lo que va de año",
  "calendar.yesterday": "Ayer",
  "charts.averageOverThePeriod": "Promedio durante el período",
  "charts.calendarView": "Vista de calendario",
  "charts.charts": "Gráficos",
  "charts.chartView": "Vista de gráfico",
  "charts.comparison": "Comparación",
  "charts.customizeComparisonMetrics": "Personalizar métricas de comparación",
  "charts.customizeComparisonMetricsDescription": "Arrastra los elementos para reordenar tus métricas de comparación. Toca el icono del ojo para mostrar u ocultar métricas.",
  "charts.loading": "Cargando el gráfico",
  "charts.maxOverThePeriod": "Máximo durante el período",
  "charts.measureToDisplay": "Medidas para mostrar",
  "charts.minMaxRange": "Mín. / Máx.",
  "charts.noDataForThisPeriod": "No hay datos para este período",
  "charts.observations": "Observaciones",
  "charts.observedTemperature": "Temperatura observada",
  "charts.seriesTableDate": "Fecha",
  "charts.showComparison": "Mostrar comparación",
  "charts.stationComparison": "Comparación de estaciones",
  "charts.stationComparisonDescription": "Compara datos meteorológicos históricos con otra estación",
  "charts.sumOverThePeriod": "Acumulado durante el período",
  "charts.tableLabel": "Tabla de {chart}",
  "charts.toggleSeries": "Mostrar u ocultar {series}",
  "charts.viewAsChart": "Gráfico",
  "charts.viewAsList": "Lista",
  "charts.viewAsPeriods": "Franjas",
  "charts.viewAsTable": "Tabla",
  "charts.viewLabel": "Vista de {chart}",
  "common.add": "Agregar",
  "common.altitude": "Altitud",
  "common.analysis": "Análisis",
  "common.average": "Promedio",
  "common.back": "Atrás",
  "common.backToHome": "Volver al inicio",
  "common.cancel": "Cancelar",
  "common.cannotBeEmpty": "Este campo no puede estar vacío.",
  "common.close": "Cerrar",
  "common.dailyForecast": "Pronóstico diario",
  "common.default": "Predeterminado",
  "common.delete": "Borrar",
  "common.details": "Detalles",
  "common.edit": "Editar",
  "common.exitFullscreen": "Salir de pantalla completa",
  "common.forecast": "Pronóstico",
  "common.frequency": "Frecuencia",
  "common.full": "Completo",
  "common.fullscreen": "Pantalla completa",
  "common.help": "Ayuda",
  "common.hidden": "Ocultos",
  "common.high": "Alto",
  "common.iDontKnowYet": "Aún no lo sé",
  "common.indoor": "Interior",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Última actualización",
  "common.low": "Bajo",
  "common.maximum": "Máximo",
  "common.medium": "Medio",
  "common.minimum": "Mínimo",
  "common.more": "Más",
  "common.moreInformation": "Más información",
  "common.next": "Siguiente",
  "common.no": "No",
  "common.noAccountNeeded": "No se necesita cuenta",
  "common.noItemsAvailable": "No hay elementos disponibles",
  "common.notNow": "Ahora no",
  "common.now": "Ahora",
  "common.openSettings": "Abrir configuración",
  "common.outdoor": "Exterior",
  "common.pageNotFound": "Página no encontrada",
  "common.pageNotFoundDescription": "La página que buscas no existe o ha sido movida.",
  "common.rain": "Lluvia",
  "common.reorderCancel": "Movimiento cancelado: {item}. De vuelta en la posición {position} de {count}.",
  "common.reorderEnd": "Elemento soltado: {item}. Posición {position} de {count}.",
  "common.reorderInstructions": "Para mover este elemento, pulsa Espacio o Intro, elige su lugar con las flechas arriba y abajo, y vuelve a pulsar Espacio o Intro para soltarlo, o Escape para cancelar.",
  "common.reorderOver": "{item}: ahora en la posición {position} de {count}.",
  "common.reorderStart": "Elemento seleccionado: {item}. Posición {position} de {count}.",
  "common.share": "Compartir",
  "common.shareImageFailed": "No se pudo compartir la imagen",
  "common.shareYourWeather": "Comparte tu clima",
  "common.skip": "Saltar",
  "common.start": "Comenzar",
  "common.unknown": "Desconocido",
  "common.validate": "Confirmar",
  "common.validEmail": "Se requiere una dirección de correo electrónico válida.",
  "common.very_low": "Muy bajo",
  "common.weatherObservations": "Observaciones meteorológicas",
  "common.welcome": "¡Bienvenido a SmartMixin!",
  "common.wind": "Viento",
  "common.yes": "Sí",
  "common.zoomImage": "Ampliar imagen",
  "compass.E": "E",
  "compass.E_long": "Este",
  "compass.ENE": "ENE",
  "compass.ENE_long": "Este-Noreste",
  "compass.ESE": "ESE",
  "compass.ESE_long": "Este-Sureste",
  "compass.N": "N",
  "compass.N_long": "Norte",
  "compass.NE": "NE",
  "compass.NE_long": "Noreste",
  "compass.NNE": "NNE",
  "compass.NNE_long": "Norte-Noreste",
  "compass.NNW": "NNO",
  "compass.NNW_long": "Norte-Noroeste",
  "compass.NW": "NO",
  "compass.NW_long": "Noroeste",
  "compass.S": "S",
  "compass.S_long": "Sur",
  "compass.SE": "SE",
  "compass.SE_long": "Sureste",
  "compass.SSE": "SSE",
  "compass.SSE_long": "Sur-Sureste",
  "compass.SSW": "SSO",
  "compass.SSW_long": "Sur-Suroeste",
  "compass.SW": "SO",
  "compass.SW_long": "Suroeste",
  "compass.W": "O",
  "compass.W_long": "Oeste",
  "compass.WNW": "ONO",
  "compass.WNW_long": "Oeste-Noroeste",
  "compass.WSW": "OSO",
  "compass.WSW_long": "Oeste-Suroeste",
  "dashboard.currentObservations": "Última medición",
  "dashboard.currentRainEvent": "Evento de lluvia actual",
  "dashboard.currentWeatherConditions": "Condiciones actuales",
  "dashboard.customizeDashboard": "Personalizar",
  "dashboard.customizeDashboardDescription": "Arrastra los elementos para reordenar tu panel. Toca el icono del ojo para mostrar u ocultar secciones.",
  "dashboard.dashboard": "Dashboard",
  "dashboard.dayRangeExpected": "{value} previsto a las {time}",
  "dashboard.dayRangeReached": "{value} a las {time}",
  "dashboard.dayRangeSteady": "Estable en {value} todo el día",
  "dashboard.hiddenSensors": "Sensores ocultos",
  "dashboard.hideSensor": "Ocultar {sensor}",
  "dashboard.lastRainEvent": "Último evento de lluvia",
  "dashboard.lastVisibleSensor": "Al menos un sensor debe seguir visible.",
  "dashboard.manageSensors": "Gestionar sensores",
  "dashboard.manageSensorsDescription": "Arrastra elementos para reordenar los sensores. Toca el icono del ojo para mostrar u ocultar sensores. Toca un nombre para renombrarlo.",
  "dashboard.manageSensorsDescriptionWeb": "Haz clic en el lápiz para renombrar un sensor, arrastra su asa para reordenar la lista y haz clic en el ojo para ocultarlo o mostrarlo.",
  "dashboard.moveSensor": "Mover {sensor}",
  "dashboard.pressureSummary": "Resumen de presión",
  "dashboard.rainEvents": "Eventos de lluvia",
  "dashboard.rainSummary": "Resumen de lluvia",
  "dashboard.renameSensor": "Cambiar el nombre de {sensor}",
  "dashboard.shareOutdoorMeasures": "Comparte tus medidas exteriores",
  "dashboard.shareOutdoorMeasuresDescription": "Únete a la comunidad SmartMixin haciendo que tus mediciones al aire libre sean visibles para los demás. Las medidas en interiores no se compartirán.",
  "dashboard.showSensor": "Mostrar {sensor}",
  "dashboard.temperatureSummary": "Resumen de temperatura",
  "dashboard.useDefaultSensorName": "Usar el nombre predeterminado",
  "dashboard.windSummary": "Resumen de viento",
  "devices.batteryLevel": "Nivel de batería",
  "devices.firmwareVersion": "Versión de firmware",
  "devices.moduleCount": "{count, plural, one {# módulo} other {# módulos}}",
  "devices.moduleType": "Tipo de módulo",
  "devices.noNetatmoWeatherStationYet": "Todavía no tienes una estación meteorológica Netatmo.",
  "devices.noOutdoorModule": "No hay ningún módulo exterior en funcionamiento para esta estación.",
  "devices.notReachable": "Sin conexión",
  "devices.serialNumber": "Número de serie",
  "devices.signalAverage": "Regular",
  "devices.signalBad": "Débil",
  "devices.signalGood": "Buena",
  "devices.signalStrength": "Intensidad de la señal",
  "devices.signalUnknown": "Desconocida",
  "devices.visitNetatmoWebsite": "Sitio web Netatmo",
  "devices.wifiStrength": "Potencia de Wi-Fi",
  "forecastMaps.addColor": "Añadir color",
  "forecastMaps.addLayer": "Añadir capa",
  "forecastMaps.autoDescription": "El mejor disponible para esta vista",
  "forecastMaps.autoDescriptionFree": "Las cuentas gratuitas usan {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Ahora se muestra {model}: {previous} cubre el {coverage, number, percent} de esta vista",
  "forecastMaps.backToMaps": "Volver a los mapas",
  "forecastMaps.build": "Generar",
  "forecastMaps.buildCompleted": "Generación completada",
  "forecastMaps.builderMetaDescription": "Crea mapas de pronóstico personalizados a partir de las capas de los modelos meteorológicos.",
  "forecastMaps.builderTitle": "Creador de mapas",
  "forecastMaps.buildFailed": "La generación ha fallado. Inténtalo de nuevo.",
  "forecastMaps.buildNotPossible": "Este mapa aún no se puede generar — no hay datos de pronóstico disponibles.",
  "forecastMaps.buildProgress": "Renderizando… {completed}/{total} pasos",
  "forecastMaps.buildStarting": "Iniciando la generación…",
  "forecastMaps.byModel": "Por modelo",
  "forecastMaps.byZone": "Por zona",
  "forecastMaps.colormap": "Paleta de colores",
  "forecastMaps.colormapCustom": "Colores personalizados",
  "forecastMaps.colormapGroupDomain": "Paletas meteorológicas",
  "forecastMaps.colormapGroupMatplotlib": "Paletas científicas",
  "forecastMaps.colorStop": "Color {position}",
  "forecastMaps.configUnavailable": "Este mapa de pronóstico no está disponible. Se muestra {name} en su lugar.",
  "forecastMaps.contourLevels": "Niveles de contorno",
  "forecastMaps.countryCanada": "Canadá",
  "forecastMaps.countryFrance": "Francia",
  "forecastMaps.countryGermany": "Alemania",
  "forecastMaps.countryItaly": "Italia",
  "forecastMaps.countryScandinavia": "Escandinavia",
  "forecastMaps.countrySpain": "España",
  "forecastMaps.countrySwitzerland": "Suiza",
  "forecastMaps.countryUnitedStates": "Estados Unidos",
  "forecastMaps.coverageUnknown": "Zona desconocida",
  "forecastMaps.coversView": "Cubre el {coverage, number, percent} de esta vista",
  "forecastMaps.customColormapMinColors": "Una paleta personalizada necesita al menos dos colores",
  "forecastMaps.customExtent": "Extensión personalizada",
  "forecastMaps.displayName": "Nombre visible",
  "forecastMaps.downscaling": "Factor de espaciado de las barbas",
  "forecastMaps.dpi": "PPP",
  "forecastMaps.drawArea": "Dibujar área",
  "forecastMaps.east": "Este",
  "forecastMaps.extentDrawHint": "Arrastra sobre el mapa para dibujar el área",
  "forecastMaps.extentInvalid": "El oeste debe ser menor que el este y el sur menor que el norte",
  "forecastMaps.frameTime": "Hora del pronóstico",
  "forecastMaps.height": "Altura (pulgadas)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "En esta zona",
  "forecastMaps.invalidHexColor": "Color no válido — usa #RRGGBB",
  "forecastMaps.layerHasErrors": "Esta capa tiene errores",
  "forecastMaps.layers": "Capas",
  "forecastMaps.layerTypeBarbs": "Barbas de viento",
  "forecastMaps.layerTypeContour": "Líneas de contorno",
  "forecastMaps.layerTypeFilledContour": "Contornos rellenos",
  "forecastMaps.layerTypeMagnitude": "Magnitud",
  "forecastMaps.layerTypeRaster": "Ráster",
  "forecastMaps.layerTypeVectorField": "Campo vectorial",
  "forecastMaps.leave": "Salir",
  "forecastMaps.levelsCount": "Cantidad",
  "forecastMaps.levelsInvalid": "Niveles de contorno no válidos",
  "forecastMaps.levelsModeArange": "Paso fijo",
  "forecastMaps.levelsModeExplicit": "Valores explícitos",
  "forecastMaps.levelsModeLinspace": "Espaciado uniforme (cantidad)",
  "forecastMaps.levelsStep": "Paso",
  "forecastMaps.levelsValues": "Valores",
  "forecastMaps.levelsValuesHint": "Separados por comas, ascendentes",
  "forecastMaps.loadingMaps": "Cargando mapas…",
  "forecastMaps.localTimeHint": "Se muestra en tu hora local",
  "forecastMaps.lockedConfig": "{model} es un modelo Premium. Se muestra {fallback} en su lugar.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Descripción",
  "forecastMaps.mapName": "Nombre del mapa",
  "forecastMaps.mapNameRequired": "Introduce un nombre",
  "forecastMaps.mapSettings": "Ajustes del mapa",
  "forecastMaps.maxLayersReached": "Este mapa ha alcanzado el máximo de {max} capas.",
  "forecastMaps.maxValue": "Valor máximo",
  "forecastMaps.memoryBudgetExceeded": "La resolución supera el presupuesto de renderizado — reduce los PPP o la altura",
  "forecastMaps.memoryBudgetUsage": "Presupuesto de renderizado: {percent}%",
  "forecastMaps.metaDescription": "Mapas de pronóstico animados generados a partir de los modelos meteorológicos.",
  "forecastMaps.metric": "Medida",
  "forecastMaps.metricRequired": "Selecciona una medida",
  "forecastMaps.metricUnavailable": "No disponible para este modelo",
  "forecastMaps.minBelowMax": "El mínimo debe ser menor que el máximo",
  "forecastMaps.minMaxRequired": "Los valores mínimo y máximo son obligatorios para este tipo de capa",
  "forecastMaps.minValue": "Valor mínimo",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} cubre el {coverage, number, percent} de esta vista",
  "forecastMaps.modelNoRun": "Aún no hay ninguna pasada completada",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Bajar",
  "forecastMaps.moveLayerUp": "Subir",
  "forecastMaps.nanClipToMin": "Limitar al mínimo",
  "forecastMaps.nanMask": "Enmascarar",
  "forecastMaps.nanPolicy": "Datos faltantes",
  "forecastMaps.nanSkip": "Omitir",
  "forecastMaps.noCompletedRun": "Este mapa aún no se ha generado. Vuelve a comprobarlo pronto.",
  "forecastMaps.noLayers": "Aún no hay capas. Añade una capa para empezar.",
  "forecastMaps.noMapsAvailable": "Todavía no hay mapas de pronóstico disponibles.",
  "forecastMaps.north": "Norte",
  "forecastMaps.opacity": "Opacidad",
  "forecastMaps.openAsAnimation": "Abrir como animación",
  "forecastMaps.otherAreas": "Otras zonas",
  "forecastMaps.outsideArea": "No cubre esta zona",
  "forecastMaps.overlayLegend": "Leyenda",
  "forecastMaps.pause": "Pausa",
  "forecastMaps.play": "Reproducir",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "No se pudo cargar el pronóstico para este punto.",
  "forecastMaps.pointValueLoading": "Cargando pronóstico…",
  "forecastMaps.pointValueUnavailable": "No hay datos para esta hora.",
  "forecastMaps.premiumModelForView": "{model} cubre esta vista",
  "forecastMaps.premiumRequired": "Los mapas de pronóstico requieren Premium",
  "forecastMaps.preview": "Vista previa",
  "forecastMaps.previewEmptyHint": "Configura al menos una capa válida para renderizar una vista previa.",
  "forecastMaps.previewFailed": "La vista previa ha fallado",
  "forecastMaps.previewHour": "Hora de pronóstico",
  "forecastMaps.previewRendering": "Renderizando la vista previa…",
  "forecastMaps.projection": "Proyección",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Estereográfica",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "América del Norte",
  "forecastMaps.removeColor": "Eliminar color",
  "forecastMaps.removeLayer": "Eliminar capa",
  "forecastMaps.retry": "Reintentar",
  "forecastMaps.run": "Pasada: {run}",
  "forecastMaps.runNotDisplayable": "Esta pasada no se puede mostrar en el mapa interactivo.",
  "forecastMaps.save": "Guardar",
  "forecastMaps.selectExtentOnMap": "Seleccionar área en el mapa",
  "forecastMaps.showArea": "Ver zona",
  "forecastMaps.showAreaOf": "Ver zona, {model}",
  "forecastMaps.south": "Sur",
  "forecastMaps.switchToModel": "Cambiar a {model}",
  "forecastMaps.title": "Mapas de pronóstico",
  "forecastMaps.uMetric": "Componente U",
  "forecastMaps.unitConversion": "Conversión de unidades",
  "forecastMaps.unitNone": "Ninguna",
  "forecastMaps.unsavedChangesBody": "Tienes cambios sin guardar. ¿Salir y descartarlos?",
  "forecastMaps.unsavedChangesTitle": "Cambios sin guardar",
  "forecastMaps.useCurrentView": "Usar vista actual",
  "forecastMaps.useModelDomain": "Desactivado: se usa el dominio completo del modelo",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Las medidas U y V deben ser diferentes",
  "forecastMaps.valueAtMapCentre": "Valor en el centro del mapa",
  "forecastMaps.valueBetween": "Debe estar entre {min} y {max}",
  "forecastMaps.variable": "Variable",
  "forecastMaps.variableMissing": "{variable} no disponible",
  "forecastMaps.variableOnlyFrom": "{variable} solo procede de {model}",
  "forecastMaps.viewMap": "Ver mapa",
  "forecastMaps.vMetric": "Componente V",
  "forecastMaps.west": "Oeste",
  "forecastMaps.windAnimation": "Animación del viento",
  "forecastModels.addForecastModel": "Añadir un modelo",
  "forecastModels.atYourStations": "Disponibles en tus estaciones",
  "forecastModels.comparisonLoadError": "No se pudo cargar la comparación de modelos de pronóstico",
  "forecastModels.coverageLoading": "Calculando qué estaciones cubre cada modelo…",
  "forecastModels.description_AROME": "Modelo de alta resolución de Météo France con resolución de convección sobre Europa occidental a 1,3 km. El mejor en su clase para previsiones a corto plazo en Francia; se actualiza cada tres horas.",
  "forecastModels.description_ARPEGE_EU": "El dominio anidado europeo del modelo ARPEGE de Météo France con resolución de 10 km. Previsiones a medio plazo sobre Europa, actualizadas cuatro veces al día.",
  "forecastModels.description_ARPEGE_GLOBAL": "Modelo global numérico del tiempo de Météo France con resolución de 25 km, hasta unos 4 días. Actualizado cuatro veces al día.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI de DMI: un modelo con resolución de convección sobre el noroeste de Europa — Dinamarca, el Benelux, Irlanda, el Reino Unido y Escandinavia — con resolución de 2 km que llega hasta 60 horas, actualizado ocho veces al día. Contiene datos abiertos de DMI modificados (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (Sistema Global de Predicción Determinista) de Environment Canada: un modelo mundial a medio plazo con resolución de 15 km que llega hasta 10 días, actualizado dos veces al día.",
  "forecastModels.description_EC_HRDPS": "Sistema Determinista de Predicción de Alta Resolución de Environment Canada: un modelo con resolución de convección sobre Canadá y el norte de Estados Unidos con resolución de 2,5 km que llega hasta 48 horas, actualizado cuatro veces al día.",
  "forecastModels.description_EC_RDPS": "Sistema Regional Determinista de Predicción de Environment Canada: un modelo a medio plazo sobre Norteamérica con resolución de 10 km, actualizado cuatro veces al día.",
  "forecastModels.description_ECMWF_HRES": "El modelo insignia de alta resolución (IFS) del Centro Europeo de Predicción a Plazo Medio, ampliamente considerado el mejor sistema de predicción global del mundo. Cubre todo el planeta con una resolución de 25 km hasta 15 días, actualizado cuatro veces al día. Contiene datos abiertos de ECMWF modificados (CC BY 4.0).",
  "forecastModels.description_GFS": "El modelo global emblemático a medio plazo de la NOAA. Cubre todo el planeta con resolución de 25 km hasta 16 días, actualizado cuatro veces al día.",
  "forecastModels.description_HRRR_CONUS": "El High-Resolution Rapid Refresh de la NOAA: un modelo con resolución de convección sobre los Estados Unidos continentales a 3 km, actualizado cada hora. Adecuado para previsiones a muy corto plazo de tormentas y meteorología severa.",
  "forecastModels.description_ICON": "El modelo global ICON del DWD con una resolución de 13 km que cubre todo el planeta hasta 7,5 días, actualizado cuatro veces al día. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I de ItaliaMeteo, operado junto con ARPAE: un modelo con resolución de convección sobre Italia con resolución de 2,2 km que llega hasta 72 horas, actualizado dos veces al día. Contiene datos abiertos de ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "La pasada de control de ICON-CH1-EPS de MeteoSwiss: un modelo con resolución de convección sobre los Alpes con resolución de 1 km que llega hasta 33 horas, actualizado cada tres horas.",
  "forecastModels.description_ICON_CH2": "La pasada de control de ICON-CH2-EPS de MeteoSwiss: un modelo con resolución de convección sobre los Alpes — Suiza y la región alpina circundante — con resolución de 2,1 km que llega hasta 120 horas, actualizado cuatro veces al día.",
  "forecastModels.description_ICON_DE": "Modelo de alta resolución de DWD con resolución de convección sobre Alemania y países circundantes a 2,2 km. Previsiones a corto plazo actualizadas dos veces al día. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "El dominio anidado europeo del modelo ICON de DWD con resolución de 7 km que cubre Europa y el Atlántico norte. Previsiones a medio plazo actualizadas cuatro veces al día. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "El servicio abierto de previsión meteorológica del Instituto Meteorológico Noruego, que combina modelos nórdicos de alta resolución con datos del ECMWF para ofrecer previsiones mundiales hasta 10 días.",
  "forecastModels.description_MF_AROME_ANTILLES": "Dominio anidado de AROME sobre las Antillas francesas (Guadalupe, Martinica) a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "forecastModels.description_MF_AROME_GUYANE": "Dominio anidado de AROME sobre la Guayana Francesa a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Dominio anidado de AROME sobre Nueva Caledonia a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Dominio anidado de AROME sobre la Polinesia Francesa a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Dominio anidado de AROME sobre Reunión y Mayotte a 2,5 km de resolución. Previsiones a corto plazo actualizadas cuatro veces al día.",
  "forecastModels.description_RRFS_CONUS": "El Rapid Refresh Forecast System de la NOAA sobre los Estados Unidos continentales con 3 km de resolución. Pronósticos horarios actualizados ocho veces al día, hasta 84 horas en las cuatro pasadas principales y 18 horas en las demás.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "El Rapid Refresh Forecast System de la NOAA que cubre toda América del Norte con 13 km de resolución. Pronósticos horarios hasta 84 horas, actualizados cuatro veces al día.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Previsión insignia de SmartMixin. Para cada hora en tu ubicación, elegimos el mejor modelo disponible — normalmente un modelo regional de alta resolución cuando existe uno (AROME en Francia, ICON-D2 en Alemania, HRRR en EE. UU., ARPEGE Europe en el continente…) y recurrimos a un modelo global en otros lugares — y luego rellenamos las lagunas con fuentes vecinas. El resultado es una única previsión continua que cubre cualquier lugar del mundo hasta 14 días, actualizada automáticamente cada vez que se actualiza alguno de los modelos subyacentes.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Previsión global propietaria de Weatherflow que combina múltiples modelos meteorológicos numéricos con observaciones de su red de estaciones meteorológicas Tempest. Horizonte mundial de 10 días.",
  "forecastModels.everywhereElse": "En cualquier otro lugar",
  "forecastModels.everywhereElseFoot": "Se usa en cualquier estación que tus modelos preferidos no alcancen.",
  "forecastModels.everywhereElsePick": "Elige uno",
  "forecastModels.fallbackBlend": "Mezcla SmartMixin",
  "forecastModels.fallbackBlendSub": "Combina varios modelos, cada uno donde es más fuerte.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES allí donde alcanza.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "El modelo global de la NOAA. Lo que usan hoy todas las cuentas.",
  "forecastModels.fallbackResolution": "Máxima resolución",
  "forecastModels.fallbackResolutionSub": "La malla más fina disponible en cada estación.",
  "forecastModels.forecastChipLabelWithRun": "{model}, pasada {run}",
  "forecastModels.forecastChipRunHint": "Mantén pulsado para mostrar u ocultar la última pasada",
  "forecastModels.forecastComparisonDescription": "Compara fácilmente los datos del modelo de pronóstico de múltiples fuentes",
  "forecastModels.forecastFollowingPreferences": "Según tus preferencias",
  "forecastModels.forecastLoadError": "No se pudo cargar el pronóstico",
  "forecastModels.forecastModel": "Modelo de pronóstico",
  "forecastModels.forecastModelAbout": "Acerca de {model}",
  "forecastModels.forecastModelComparison": "Comparación de modelos de pronóstico",
  "forecastModels.forecastModelCoverage": "Cobertura",
  "forecastModels.forecastModelDescription": "Descripción",
  "forecastModels.forecastModels": "Modelos de pronóstico",
  "forecastModels.forecastModelScopeGlobal": "Global",
  "forecastModels.forecastModelScopeGlobalDescription": "Este modelo cubre todo el planeta.",
  "forecastModels.forecastModelScopeRegional": "Regional",
  "forecastModels.forecastModelScopeRegionalDescription": "Este modelo solo cubre una región específica.",
  "forecastModels.forecastModelSpecifications": "Especificaciones",
  "forecastModels.forecastNoPinLocation": "Ningún modelo preferido alcanza esta ubicación; decide «en cualquier otro lugar».",
  "forecastModels.forecastNoPinStation": "Ningún modelo preferido alcanza esta estación; decide «en cualquier otro lugar».",
  "forecastModels.forecastNoPreferredModels": "Aún no hay modelos preferidos definidos.",
  "forecastModels.forecastOverrideElsewhere": "Tus preferencias se aplican en cualquier otro lugar.",
  "forecastModels.forecastPickForLocation": "O elige uno para esta ubicación",
  "forecastModels.forecastPickForStation": "O elige uno para esta estación",
  "forecastModels.forecastPinWinsLocation": "{model} — tu primer modelo preferido que alcanza esta ubicación.",
  "forecastModels.forecastPinWinsStation": "{model} — tu primer modelo preferido que alcanza esta estación.",
  "forecastModels.forecastServedNowHere": "Ahora mismo aquí es {model}",
  "forecastModels.forecastSetForLocation": "Definido para esta ubicación",
  "forecastModels.forecastSetForStation": "Definido para esta estación",
  "forecastModels.forecastSettingsRowSub": "Modelos preferidos, y qué se aplica en cualquier otro lugar",
  "forecastModels.forecastStopUsingHere": "Dejar de usar aquí",
  "forecastModels.forecastUseForLocation": "Usar {model} para esta ubicación",
  "forecastModels.forecastUseForStation": "Usar {model} para esta estación",
  "forecastModels.forecastUsePreferred": "Usar mis modelos preferidos",
  "forecastModels.frequencyHourly": "Cada hora",
  "forecastModels.horizon": "Horizonte",
  "forecastModels.horizonValue": "hasta {value} horas",
  "forecastModels.meshSize": "Tamaño de cuadrícula",
  "forecastModels.pickerShowAll": "Mostrar el catálogo completo",
  "forecastModels.pickerUnreachable": "{count, plural, one {# modelo más no alcanza} other {# modelos más no alcanzan}} ninguna de tus estaciones",
  "forecastModels.pinInUse": "En uso",
  "forecastModels.pinShadowed": "Nunca se usa — un modelo superior cubre todas tus estaciones",
  "forecastModels.pinSlots": "{used} de {max} · elige un modelo",
  "forecastModels.pinSlotsFull": "{max, plural, one {La única plaza está ocupada. Quita su modelo para añadir otro.} other {Las # plazas están ocupadas. Quita una para añadir otra.}}",
  "forecastModels.pinsUncoveredCount": "{used} de {count, plural, one {tu # estación} other {tus # estaciones}}: ningún modelo preferido {used, plural, one {la alcanza} other {las alcanza}}; decide «en cualquier otro lugar».",
  "forecastModels.pinsUncoveredNamed": "{stations}: ningún modelo preferido {count, plural, one {la alcanza} other {las alcanza}}; decide «en cualquier otro lugar».",
  "forecastModels.pinUnreachable": "Nunca se usa — no alcanza ninguna de tus estaciones",
  "forecastModels.pinUsedAt": "Se usa en {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Se usa en tu estación} other {Se usa en las # estaciones}}",
  "forecastModels.pinUsedAtSome": "Se usa en {used} de {count, plural, one {# estación} other {# estaciones}}",
  "forecastModels.preferredModels": "Modelos preferidos",
  "forecastModels.preferredModelsAll": "Una lista, todas las estaciones",
  "forecastModels.preferredModelsOne": "Una lista, se aplica en todas partes",
  "forecastModels.publisher": "Editor",
  "forecastModels.removePreferredModel": "Quitar {model} de tus modelos preferidos",
  "forecastModels.resetForecastPreference": "Restablecer",
  "forecastModels.resetForecastPreferenceHint": "Borra tus modelos preferidos y vuelve al ajuste predeterminado de SmartMixin.",
  "forecastModels.servedNowMany": "Ahora mismo: GFS {count, plural, one {en tu estación} other {en las # estaciones}}.",
  "forecastModels.servedNowNone": "Ahora mismo: GFS en todas partes.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodelo",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Pronóstico Weatherflow",
  "forecastModels.weatherForecastModels": "Modelos de pronóstico del tiempo",
  "helpCenter.articleCount": "{count, plural, one {# artículo} other {# artículos}}",
  "helpCenter.articleNotFound": "Artículo no encontrado",
  "helpCenter.articleNotFoundDescription": "El artículo que buscas no existe.",
  "helpCenter.backToHelpCenter": "Volver al centro de ayuda",
  "helpCenter.browseByCategory": "Explorar por categoría",
  "helpCenter.categoryNotFound": "Categoría no encontrada",
  "helpCenter.categoryNotFoundDescription": "Esta categoría no existe o no tiene artículos.",
  "helpCenter.contactSupport": "Contactar con soporte",
  "helpCenter.feedbackHelpsImprove": "Tus comentarios nos ayudan a mejorar nuestros artículos de ayuda.",
  "helpCenter.feedbackReasonNotAnswer": "No responde a mi pregunta",
  "helpCenter.feedbackReasonOutdated": "La información está desactualizada",
  "helpCenter.feedbackReasonUnclear": "Las instrucciones no son claras",
  "helpCenter.feedbackWhatWentWrong": "¿Cuál fue el problema?",
  "helpCenter.helpCategoryAccount": "Cuenta",
  "helpCenter.helpCategoryBilling": "Facturación",
  "helpCenter.helpCategoryForecast": "Pronósticos",
  "helpCenter.helpCategoryGettingStarted": "Primeros pasos",
  "helpCenter.helpCategoryProviders": "Proveedores",
  "helpCenter.helpCategoryStations": "Estaciones",
  "helpCenter.helpCategoryTroubleshooting": "Solución de problemas",
  "helpCenter.helpCenter": "Centro de ayuda",
  "helpCenter.landingDescription": "Encuentra respuestas a preguntas frecuentes y aprende a sacar el máximo provecho de SmartMixin.",
  "helpCenter.linkToSection": "Enlace a esta sección",
  "helpCenter.menuItemDescription": "Preguntas frecuentes y guías",
  "helpCenter.minRead": "{minutes} min de lectura",
  "helpCenter.onThisPage": "En esta página",
  "helpCenter.platformMobileApp": "Aplicación móvil",
  "helpCenter.platformMobileOnly": "Solo en la aplicación móvil",
  "helpCenter.platformWebApp": "Aplicación web",
  "helpCenter.platformWebOnly": "Solo en la aplicación web",
  "helpCenter.popularArticles": "Artículos populares",
  "helpCenter.relatedArticles": "Artículos relacionados",
  "helpCenter.searchArticles": "Buscar artículos...",
  "helpCenter.stillNeedHelp": "¿Todavía necesitas ayuda?",
  "helpCenter.stillNeedHelpDescription": "Si este artículo no respondió a tu pregunta, estaré encantado de ayudarte directamente.",
  "helpCenter.supportEmailSubject": "Ayuda de SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Ayuda de SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "¡Gracias por tu opinión!",
  "helpCenter.wasArticleHelpful": "¿Te resultó útil este artículo?",
  "intro.locationDescription": "Permite el acceso a tu ubicación para recibir predicciones meteorológicas precisas adaptadas a tu área exacta — sin pronósticos genéricos.",
  "intro.locationTitle": "Pronósticos hechos para ti",
  "intro.notificationDescription": "Activa las notificaciones para recibir alertas oportunas sobre cambios del tiempo que te importan — lluvia, nieve o condiciones severas, justo cuando lo necesitas.",
  "intro.notificationsTitle": "No te pierdas ningún cambio del tiempo",
  "intro.readyDescription": "Disfruta de pronósticos precisos, información meteorológica en tiempo real y datos de estaciones de todo el mundo — todo en una aplicación potente.",
  "intro.readyTitle": "¡Todo listo!",
  "intro.welcomeDescription": "Obtén pronósticos hiperlocales de las principales agencias meteorológicas — además de acceso a más de 40.000 estaciones meteorológicas en todo el mundo para ver las condiciones reales, presentes y pasadas.",
  "intro.welcomeTitle": "Tu pronóstico reinventado",
  "landing.alsoAvailableOn": "También disponible en:",
  "landing.featureAlertsDescription": "Establece umbrales personalizados para cualquier métrica. Recibe notificaciones cuando la temperatura baje, comience a llover o se levante el viento.",
  "landing.featureAlertsTitle": "Alertas inteligentes",
  "landing.featureAnalyticsDescription": "Gráficos interactivos, análisis de tendencias y estadísticas detalladas. Profundiza en datos de temperatura, humedad, presión, lluvia y viento.",
  "landing.featureAnalyticsTitle": "Análisis avanzados",
  "landing.featureExportDescription": "Recibe todos tus datos meteorológicos por correo electrónico en una hoja de cálculo de Excel, lista para analizarlos en Excel, Google Sheets o tus herramientas favoritas.",
  "landing.featureExportTitle": "Exporta tus datos",
  "landing.featureForecastDescription": "Accede a {count, plural, one {#+ modelo de pronóstico profesional} other {#+ modelos de pronóstico profesionales}}, incluidos ECMWF, GFS y modelos regionales. Compáralos lado a lado para hacer tus propias predicciones.",
  "landing.featureForecastTitle": "Compara modelos de pronóstico",
  "landing.featureHistoryDescription": "Accede a datos históricos con escala horaria, diaria y mensual. Expórtalos a Excel para investigación o archivos personales.",
  "landing.featureHistoryTitle": "Historial completo",
  "landing.featureMultiBrandDescription": "Conecta Netatmo, Davis, Tempest, Ecowitt, Ambient Weather y más. No más cambiar entre aplicaciones.",
  "landing.featureMultiBrandTitle": "Todas las marcas, una app",
  "landing.featuresSubtitle": "SmartMixin te da las herramientas para analizar, comparar y entender tus datos meteorológicos como un profesional.",
  "landing.featuresTitle": "Diseñado para amantes de los datos",
  "landing.finalCtaButton": "Crear cuenta gratuita",
  "landing.finalCtaSubtitle": "Únete a miles de entusiastas del clima que confían en SmartMixin.",
  "landing.finalCtaTitle": "¿Listo para profundizar en tus datos meteorológicos?",
  "landing.heroCta": "Empezar gratis",
  "landing.heroDescription": "Análisis profundos, gráficos hermosos y pronósticos profesionales — todas tus estaciones meteorológicas unificadas en una potente aplicación.",
  "landing.heroSecondaryCta": "Explorar el mapa",
  "landing.heroTagline": "Para entusiastas del clima",
  "landing.heroTitle": "Ve tu clima como nunca antes",
  "landing.pricingComparisonCaption": "Comparación de funciones del plan gratuito y Premium",
  "landing.pricingFeatureAdvancedMetrics": "Métricas avanzadas",
  "landing.pricingFeatureAlerts": "Alertas personalizadas",
  "landing.pricingFeatureColumn": "Función",
  "landing.pricingFeatureExport": "Exportación de datos (Excel)",
  "landing.pricingFeatureForecastComparison": "Comparación de pronósticos",
  "landing.pricingFeatureForecasts": "Modelos de pronóstico",
  "landing.pricingFeatureForecastsFreeTier": "1 modelo",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ modelo} other {#+ modelos}}",
  "landing.pricingFeatureReports": "Análisis e informes",
  "landing.pricingFeatureStationComparison": "Comparación de estaciones",
  "landing.pricingFeatureWidgets": "Widgets de pantalla de inicio",
  "landing.pricingFeatureYearOverYear": "Análisis interanual",
  "landing.pricingFreeCta": "Empezar",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Más popular",
  "landing.pricingPremiumCta": "Empezar",
  "landing.pricingPremiumDescription": "Desde 1,99 €/mes — suscríbete en la web, App Store o Google Play",
  "landing.pricingSubtitle": "Empieza gratis, mejora cuando necesites más potencia.",
  "landing.pricingTitle": "Precios simples y transparentes",
  "landing.statBrands": "Marcas compatibles",
  "landing.statForecasts": "Modelos de pronóstico",
  "landing.statStations": "Estaciones meteorológicas",
  "landing.supportedDevicesNote": "Además, más de {count, number} estaciones públicas de la red de la Organización Meteorológica Mundial",
  "landing.supportedDevicesSubtitle": "Conecta tu estación meteorológica existente en minutos. Somos compatibles con {count, plural, one {# marca importante} other {# marcas importantes}}, y cada vez más.",
  "landing.supportedDevicesTitle": "Funciona con tu estación",
  "metrics.absolutePressure": "Presión absoluta",
  "metrics.airDensity": "Densidad del aire",
  "metrics.airGap": "Espacio de aire",
  "metrics.apparentTemperature": "Temperatura aparente",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Prom.",
  "metrics.avg_wind": "Viento medio",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Temp. globo negro",
  "metrics.boilerOn": "Calentador encendido",
  "metrics.boilerOnInHours": "Calentador encendido (horas)",
  "metrics.cloudCover": "Nubosidad",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Conductividad",
  "metrics.dailyPrecipitation": "Precipitación diaria",
  "metrics.dailyRain": "Lluvia diaria",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Profundidad",
  "metrics.depthSensors": "Sensores de profundidad",
  "metrics.dewPoint": "Punto de rocío",
  "metrics.distance": "Distancia",
  "metrics.downTrend": "abajo",
  "metrics.ET": "Evapotranspiración",
  "metrics.etToday": "ET hoy",
  "metrics.feelsLike": "Sensación térmica",
  "metrics.feelsLikeWithFormula": "Sensación térmica ({formula})",
  "metrics.frostPoint": "Punto de escarcha",
  "metrics.gust": "Ráfaga",
  "metrics.gustDirection": "Dirección de la ráfaga",
  "metrics.hail": "Granizo",
  "metrics.heatIndex": "Índice de calor",
  "metrics.heatingDegreeDays": "Grados día de calefacción",
  "metrics.heatingPower": "Potencia de calefacción",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Humedad",
  "metrics.lastLightningImpact": "Último impacto",
  "metrics.lastMeasure": "Última medida",
  "metrics.leafSensors": "Sensores de hoja",
  "metrics.leafWetness": "Humedad de la hoja",
  "metrics.lightningDistance": "Distancia",
  "metrics.lightningStrikeCount": "Número de rayos",
  "metrics.lightningStrikeDistance": "Distancia del rayo",
  "metrics.max": "Máx.",
  "metrics.max_gust": "Ráfaga máx.",
  "metrics.maxToday": "Máx. hoy",
  "metrics.min": "Mín.",
  "metrics.noise": "Ruido",
  "metrics.normalizedHeatingCoefficient": "Coeficiente de calentamiento normalizado",
  "metrics.outdoorTemperature": "Temperatura exterior",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Precipitaciones",
  "metrics.pressure": "Presión",
  "metrics.rain": "Lluvia",
  "metrics.rainDurationValue": "Duración de la lluvia: {duration}",
  "metrics.rainfallMeasurement": "Medición de precipitaciones",
  "metrics.rainRate": "Intensidad de lluvia",
  "metrics.relativePressure": "Presión relativa",
  "metrics.setPoint": "Consigna",
  "metrics.snow": "Nieve",
  "metrics.snowfall": "Nevada",
  "metrics.soilMoisture": "Humedad",
  "metrics.soilSensors": "Sensores de tierra",
  "metrics.soilWaterTension": "Tensión hídrica del suelo",
  "metrics.solarEnergy": "Energía solar",
  "metrics.solarRadiation": "Radiación solar",
  "metrics.speed": "Velocidad",
  "metrics.stableTrend": "estable",
  "metrics.sum": "Suma",
  "metrics.temperature": "Temperatura",
  "metrics.temperatureSensors": "Sensores de temperatura y humedad",
  "metrics.temperatureShort": "Temp.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "arriba",
  "metrics.uv": "UV",
  "metrics.visibility": "Visibilidad",
  "metrics.weatherCondition": "Condición meteorológica",
  "metrics.wetBulbGlobeTemperature": "Temperatura de globo de bulbo húmedo",
  "metrics.wetBulbTemperature": "Temperatura del bulbo húmedo",
  "metrics.wind": "Viento",
  "metrics.windChill": "Enfriamiento por viento",
  "metrics.windDirection": "Dirección del viento",
  "metrics.windMeasurement": "Medida de viento",
  "metrics.windRun": "Distancia del viento",
  "metrics.windRunDescription": "La distancia del viento es la distancia total que recorre el viento durante un período de tiempo",
  "metrics.windSpeed": "Velocidad del viento",
  "navigation.allFavorites": "Ver todas",
  "navigation.breadcrumbs": "Ruta de navegación",
  "navigation.collapseNavigation": "Contraer navegación",
  "navigation.expandNavigation": "Expandir navegación",
  "navigation.main": "Principal",
  "navigation.mapShort": "Mapa",
  "navigation.skipToContent": "Ir al contenido principal",
  "navigation.stationsShort": "Estaciones",
  "network.cancelError": "Solicitud cancelada",
  "network.connectionError": "No se puede conectar al servidor",
  "network.networkError": "Red no disponible",
  "network.serverError": "Ha sucedido un problema...",
  "network.timeoutError": "El tiempo de conexión ha expirado",
  "network.unknownError": "Error desconocido",
  "premium.alreadyPremium": "¡Ya tienes una cuenta premium!",
  "premium.bestValue": "Mejor oferta",
  "premium.billingDetailsAndroid": "Prueba gratuita: no se te cobrará nada si cancelas al menos 24 horas antes de que termine la prueba. Después, tu suscripción a SmartMixin se renueva automáticamente salvo que la canceles al menos 24 horas antes del final del periodo en curso; puedes cancelarla en cualquier momento en los ajustes de tu cuenta de Google Play. Cada renovación se cobra al precio que aparece en el botón de arriba. El pago se carga en tu cuenta de Google Play al confirmar la compra y al inicio de cada periodo de renovación.",
  "premium.billingDetailsIos": "Prueba gratuita: no se te cobrará nada si cancelas al menos 24 horas antes de que termine la prueba. Después, tu suscripción a SmartMixin se renueva automáticamente salvo que la canceles al menos 24 horas antes del final del periodo en curso; puedes cancelarla en cualquier momento en los ajustes de tu cuenta de App Store. Cada renovación se cobra al precio que aparece en el botón de arriba. El pago se carga en tu cuenta de App Store al confirmar la compra y al inicio de cada periodo de renovación.",
  "premium.freeBannerBody": "Las cuentas gratuitas reciben GFS en todas partes: tus modelos preferidos y «en cualquier otro lugar» empiezan a funcionar en cuanto te suscribas.",
  "premium.freeBannerTitle": "Las preferencias se aplican con Premium",
  "premium.freeSubscription": "Suscripción Premium gratuita",
  "premium.freeTrialForPeriod": "Prueba gratuita durante {period, plural, one {# día} other {# días}}",
  "premium.getUnlimitedAccess": "Acceso ilimitado a:",
  "premium.manageMySubscription": "Administrar mi suscripción",
  "premium.notPurchasedYet": "No se ha encontrado ninguna compra de SmartMixin Premium en esta cuenta de la tienda.",
  "premium.orChooseMonthly": "O elegir mensual:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Activo",
  "premium.premiumAnnualTrialInfo": "Empieza con una prueba gratuita de {days, plural, one {# día} other {# días}}",
  "premium.premiumCurrentPlan": "Plan actual",
  "premium.premiumDownloadApp": "Descarga la aplicación para suscribirte:",
  "premium.premiumEndsOn": "Caduca el {date}",
  "premium.premiumFeatureAlerts": "Alertas meteorológicas",
  "premium.premiumFeatureAnalysis": "Análisis meteorológico avanzado",
  "premium.premiumFeatureCharts": "Comparaciones de gráficos",
  "premium.premiumFeatureExport": "Exportación de datos",
  "premium.premiumFeatureForecast": "Modelos de pronóstico regional",
  "premium.premiumFeatureNotification": "Widget de barra de estado",
  "premium.premiumFeatureTitle": "Función Premium",
  "premium.premiumFeatureWidgets": "Widgets de pantalla de inicio",
  "premium.premiumFreePlan": "Gratuito",
  "premium.premiumInactive": "No suscrito",
  "premium.premiumManageStoreSubscription": "Te suscribiste a través de {store}. Gestiona o cancela tu suscripción allí.",
  "premium.premiumManageWebSubscription": "Gestiona tu suscripción, actualiza el método de pago o cancela.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Se renueva el {date}",
  "premium.premiumSubscribeAnnual": "Anual — 9,99 €/año",
  "premium.premiumSubscribedOn": "Suscrito en {platform}",
  "premium.premiumSubscribedOnWeb": "Suscrito en la web",
  "premium.premiumSubscribeMonthly": "Mensual — 1,99 €/mes",
  "premium.premiumSubscribeOnWeb": "Suscríbete ahora para desbloquear todas las funciones premium.",
  "premium.premiumSubscriptionSuccess": "¡Tu suscripción ha sido activada! Disfruta de todas las funciones premium.",
  "premium.premiumSubscriptionSuccessTitle": "¡Bienvenido a Premium!",
  "premium.premiumWebappNotice": "La suscripción en la web no está disponible en este momento.",
  "premium.pricePerMonth": "{price}/mes",
  "premium.pricePerYear": "{price}/año",
  "premium.purchasedNetatmoPro": "Ya has comprado Netatmo Pro ({date}). Te da acceso a una parte de las funciones Premium. Suscríbete a una de las siguientes ofertas si quieres acceder a todas las funciones Premium.",
  "premium.purchaseFailed": "No se ha podido completar la compra. Inténtalo de nuevo.",
  "premium.restoreFailed": "No se han podido restaurar tus compras. Inténtalo de nuevo.",
  "premium.restorePurchase": "Restaurar la compra",
  "premium.savingsPercent": "Ahorra {percent}%",
  "premium.seePremium": "Ver Premium",
  "premium.startFreeTrial": "Iniciar prueba gratuita",
  "premium.storeUnavailable": "La tienda no está disponible en este momento. Inténtalo de nuevo más tarde.",
  "premium.subscribeNow": "Suscríbete ahora — sin prueba",
  "premium.switchToPremium": "Cambiar a SmartMixin Premium",
  "premium.thenPrice": "luego {price}",
  "providerHints.ambientWeatherApiKey": "Creada en los ajustes de tu cuenta de ambientweather.net.",
  "providerHints.davisApiSecret": "Se muestra solo una vez al crear la clave API V2 — guárdalo bien.",
  "providerHints.davisV2ApiKey": "Desde la página de claves API V2 en weatherlink.com.",
  "providerHints.ecowittApi": "Desde la página API de tu cuenta Ecowitt.",
  "providerHints.ecowittApp": "La clave de aplicación, también desde tu cuenta Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Usa el correo y la contraseña de tu cuenta My AcuRite — no el acceso de SmartMixin.",
  "providerHints.myAcuriteEmail": "El correo electrónico de tu cuenta My AcuRite — no tu acceso de SmartMixin.",
  "providerHints.myAcuritePassword": "La contraseña de tu cuenta My AcuRite.",
  "providerHints.weatherflowToken": "Token de uso personal desde tempestwx.com → ajustes → autorizaciones de datos.",
  "providerHints.wundergroundEditKey": "Usar otra clave",
  "providerHints.wundergroundKey": "Una cadena larga de la página de claves API de tu cuenta Weather Underground — no tu contraseña de wunderground.com.",
  "providerHints.wundergroundKeyExample": "ej. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Clave API verificada",
  "providerHints.wundergroundNoStationsNearby": "No se encontraron estaciones cerca de esta ubicación. Prueba a introducir un ID de estación directamente.",
  "providerHints.wundergroundStationIdExample": "ej. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Obtén tu clave API de Ambient Weather.",
  "providerIntro.davisStep2": "Obtén tu clave API V2 y secreto API de Davis.",
  "providerIntro.ecowittStep2": "Obtén tu clave API y clave de aplicación de Ecowitt.",
  "providerIntro.getStarted": "Empezar",
  "providerIntro.myAcuriteStep2": "Usa el correo y la contraseña de tu cuenta de My AcuRite existente.",
  "providerIntro.netatmoEnergyStep2": "Inicia sesión en Netatmo cuando se te solicite — no se necesita clave API.",
  "providerIntro.netatmoWeatherStep2": "Inicia sesión en Netatmo cuando se te solicite — no se necesita clave API.",
  "providerIntro.signupBanner": "Ya casi — crea tu cuenta gratuita de SmartMixin para conectar {provider}.",
  "providerIntro.step1": "Inicia sesión en tu cuenta de SmartMixin (NO en {provider}).",
  "providerIntro.step3EmailPassword": "Introdúcelos aquí.",
  "providerIntro.step3KeyOrToken": "Pégalo aquí.",
  "providerIntro.step3OAuth": "Autoriza SmartMixin en la ventana emergente.",
  "providerIntro.step3Wunderground": "Pega tu clave API y luego selecciona una estación cercana o introduce cualquier ID de estación.",
  "providerIntro.stepOfTotal": "Paso {step} de {total}",
  "providerIntro.title": "Conectar {provider}",
  "providerIntro.weatherflowStep2": "Obtén tu token de uso personal de Tempest.",
  "providerIntro.wundergroundBrowsePublic": "¿No tienes estación? Explora las públicas",
  "providerIntro.wundergroundFindNearby": "Buscar estaciones cercanas",
  "providerIntro.wundergroundOrEnterId": "O introducir un ID de estación",
  "providerIntro.wundergroundStep2": "Obtén tu clave API de Weather Underground. Después podrás conectar cualquier estación — la tuya o una pública.",
  "reports.agroMeteorology": "Agrometeorología",
  "reports.analysis": "Análisis",
  "reports.annualCumulativeRainfallComparison": "Comparación de precipitaciones anuales",
  "reports.annualHeatingDurationComparison": "Comparación anual de la duración de la calefacción",
  "reports.annualHeatingEfficiency": "Eficiencia anual de calefacción",
  "reports.annualIndoorComparison": "Comparación anual de interior",
  "reports.annualOutdoorComparison": "Comparación anual de exterior",
  "reports.annualOutdoorReport": "Reporte anual de exterior",
  "reports.annualReport": "Reporte anual",
  "reports.annualSolarReport": "Informe solar anual",
  "reports.annualWaterBalance": "Balance hídrico anual",
  "reports.annualWaterBalanceCarryOver": "Transferir {year} ({value})",
  "reports.annualWaterBalanceDescription": "El balance hídrico (versión simplificada, solo se utilizan la lluvia y la evapotranspiración) ayuda a gestionar el suministro de agua",
  "reports.avgHumidity": "Humedad media",
  "reports.avgMaxTemperature": "Media T°max",
  "reports.avgMetric": "Promedio – {metric}",
  "reports.avgMinTemperature": "Media T°min",
  "reports.avgPressure": "Presión media",
  "reports.avgTemperature": "Temperatura media",
  "reports.chartsAndTable": "Gráficos y tabla",
  "reports.climateNormalPeriodOfRecord": "Período de observación ({years, plural, one {# año} other {# años}})",
  "reports.climateNormals": "Normales climáticas",
  "reports.climateNormalStandardLabel": "Normal estándar ({period})",
  "reports.climateTrendPerDecade": "Tendencia de temperatura: {value} por década a lo largo de {years, plural, one {# año} other {# años}}",
  "reports.coldestMonthRanking": "{month} más frío registrado",
  "reports.comfortable": "Confortable (45% {lessThan} Humedad ≤ 60%)",
  "reports.cumulativeRainfall": "Precipitación acumulada",
  "reports.cumulativeRainfallDescription": "Realiza un seguimiento de la precipitación total acumulada durante el período seleccionado.",
  "reports.dailyMaxRainfall": "Precipitación máxima diaria",
  "reports.dataExport": "Exportación de datos",
  "reports.dataExportXlsxFormatDescription": "Exporta todos los datos de tu estación en formato Excel (* .xlsx). Una vez que hagas clic en el botón, recibirás un correo electrónico con los datos procesados después de unos minutos.",
  "reports.daysOfData": "{days, plural, one {# día} other {# días}} de datos",
  "reports.daysWithFrost": "Días con Heladas",
  "reports.daysWithHeavyRain": "Días de lluvia intensa (≥ {threshold})",
  "reports.daysWithoutThaw": "Días sin deshielo",
  "reports.daysWithStrongFrost": "Días con Heladas Fuertes",
  "reports.emailSent": "Se te ha enviado un correo electrónico",
  "reports.frostDays": "Días de helada",
  "reports.grasslandTemperatureSum": "Suma térmica de pastizales",
  "reports.grasslandTemperatureSumDescription": "Cuando se supera la suma {threshold} en primavera, se ha alcanzado el inicio sostenible de la vegetación (funciona en Europa)",
  "reports.growingDegreeDays": "Grados día de crecimiento",
  "reports.highPressure": "Anticiclón (Presión Prom ≥ {threshold})",
  "reports.iceDays": "Días de hielo",
  "reports.indoorReport": "Reporte de interior",
  "reports.keyFacts": "Datos Clave",
  "reports.longestDrySpell": "Período seco más largo",
  "reports.longestRunOfRainyDays": "Período más largo de días lluviosos",
  "reports.longestRunWithoutRun": "Período más largo sin lluvia",
  "reports.longestWetSpell": "Período lluvioso más largo",
  "reports.lowPressure": "Baja Presión (Presión Prom {lessThan} {threshold})",
  "reports.maxHumidity": "Humedad Máxima",
  "reports.maxMetric": "Máximo – {metric}",
  "reports.maxPressure": "Presión Máxima",
  "reports.maxTemperature": "Temperatura Máxima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Amplitud máxima (/24H)",
  "reports.minHumidity": "Humedad Mínima",
  "reports.minMetric": "Mínimo – {metric}",
  "reports.minPressure": "Presión Mínima",
  "reports.minTemperature": "Temperatura Mínima",
  "reports.minTempMagnitude24h": "Amplitud mínima (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {# día más} other {# días más}} este mes",
  "reports.monthlyAverageCountdownDetail": "Entonces aparecerán la media del mes y su clasificación.",
  "reports.monthlyAverageRule": "Las medias mensuales y las clasificaciones aparecen cuando un mes natural tiene {days, plural, one {# día} other {# días}} registrados.",
  "reports.monthlyHeatingEfficiency": "Eficiencia de calefacción mensual",
  "reports.monthlyOutdoorReport": "Reporte mensual de exterior",
  "reports.monthlyReport": "Reporte mensual",
  "reports.monthlySolarReport": "Informe solar mensual",
  "reports.monthlyWindReport": "Reporte mensual de viento",
  "reports.monthsOfData": "{months, plural, one {# mes} other {# meses}} de datos",
  "reports.numberOfDays": "Número de Días",
  "reports.outdoorReport": "Reporte de exterior",
  "reports.overviewSection": "Resumen",
  "reports.rainfall": "Precipitación",
  "reports.rainyDays": "Días Lluviosos",
  "reports.recordClimatologicalDay": "Día climatológico (06–06 UTC)",
  "reports.recordClimDayBody": "Aquí la lluvia se suma por día natural, de medianoche a medianoche en la hora de la estación. Los servicios meteorológicos la suman de 06:00 a 06:00 UTC, así que una tormenta justo antes o después de medianoche puede hacer que otro día sea el más lluvioso.",
  "reports.recordDailyRain": "Día más lluvioso",
  "reports.recordFromHourlyReadings": "De las lecturas horarias",
  "reports.recordHigh": "Récord de calor",
  "reports.recordLow": "Récord de frío",
  "reports.recordOfficialBody": "El servicio meteorológico publica una máxima y una mínima diarias para esta estación, leídas en termómetros de máxima y de mínima. Captan picos breves que las lecturas horarias no registran, por lo que sustituyen a los valores calculados a partir de las lecturas horarias.",
  "reports.recordOfficialValue": "Valor oficial",
  "reports.recordsAndClimatology": "Récords y clima",
  "reports.recordSheetTitle": "Acerca de estos récords",
  "reports.recordsSince": "Récords desde {date}",
  "reports.recordWindGust": "Racha de viento más fuerte",
  "reports.relativelyWet": "Relativamente húmedo (60 % {lessThan} Humedad ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# informe} other {# informes}}",
  "reports.sendEmail": "Enviar correo electrónico",
  "reports.summerDays": "Días de verano",
  "reports.tableScrollRegion": "{title}, se desplaza horizontalmente",
  "reports.tooDry": "Demasiado seco (Humedad ≤ 45%)",
  "reports.tooWet": "Demasiado húmedo (Humedad {greaterThan} 80%)",
  "reports.tropicalNights": "Noches Tropicales",
  "reports.unlockPremiumSubtitle": "Incluido con SmartMixin Premium",
  "reports.unlockPremiumTitle": "Desbloquea {count, plural, one {# función premium} other {# funciones premium}}",
  "reports.warmestMonthRanking": "{month} más cálido registrado",
  "reports.waterBalance": "Balance hídrico",
  "reports.yearsOfData": "{years, plural, one {# año} other {# años}} de datos",
  "reports.yearToDateTemperatureComparison": "Comparación de temperatura del año hasta la fecha",
  "sensors.bgtSensors": "Globo negro y WBGT",
  "sensors.cameraFeed": "Cámara",
  "sensors.compareHumidity": "Comparar humedad",
  "sensors.compareMoisture": "Comparar humedad del suelo",
  "sensors.comparePm25": "Comparar PM2.5",
  "sensors.compareTemperatures": "Comparar temperaturas",
  "sensors.compareWaterTension": "Comparar tensión hídrica del suelo",
  "sensors.depthByChannel": "Profundidad por canal",
  "sensors.heatStressExtreme": "Estrés térmico extremo",
  "sensors.heatStressModerate": "Estrés térmico moderado",
  "sensors.heatStressNone": "Sin estrés térmico",
  "sensors.heatStressStrong": "Estrés térmico fuerte",
  "sensors.heatStressVeryStrong": "Estrés térmico muy fuerte",
  "sensors.indoorClimate": "Clima interior",
  "sensors.indoorCo2Levels": "Niveles de CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura y humedad",
  "sensors.leafWetnessByChannel": "Humedad de las hojas por canal",
  "sensors.lightningSensor": "Rayo",
  "sensors.moistureByChannel": "Humedad del suelo por canal",
  "sensors.noDataAvailable": "No hay datos disponibles",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 por canal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Seleccionar canal",
  "sensors.sensorDetailDescription": "Ver datos históricos y tendencias de los canales del sensor.",
  "sensors.sensorHistory": "Historial del sensor",
  "sensors.soilConductivityByChannel": "Conductividad por canal",
  "sensors.soilTemperatureByChannel": "Temperatura del suelo por canal",
  "sensors.strikesToday": "Impactos hoy",
  "sensors.temperatureByChannel": "Temperatura por canal",
  "sensors.viewChart": "Ver gráfico",
  "sensors.waterTensionByChannel": "Tensión hídrica del suelo por canal",
  "settings.appearance": "Apariencia",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "árabe",
  "settings.bulgarian": "búlgaro",
  "settings.catalan": "catalán",
  "settings.chartGestures": "Gestos en gráficos",
  "settings.chartGesturesDescription": "Deslizar el dedo en los gráficos cambia el período de tiempo, pellizcar los gráficos cambia la escala de tiempo",
  "settings.choiceCount": "{count, plural, one {# disponible} other {# disponibles}}",
  "settings.contactUs": "Contáctanos",
  "settings.contactUsDescription": "Obtén ayuda o envía comentarios",
  "settings.croatian": "croata",
  "settings.czech": "checo",
  "settings.dailyDetailByPeriods": "Detalle diario por franjas",
  "settings.dailyDetailByPeriodsDescription": "Agrupa las 24 horas en noche, mañana, tarde y atardecer: la misma división que usa el resumen del día.",
  "settings.danish": "danés",
  "settings.dark": "Tema oscuro",
  "settings.dataDisplay": "Visualización de datos",
  "settings.dateAndTime": "Fecha y hora",
  "settings.donateButton": "Hacer una donación",
  "settings.donateDescription": "SmartMixin está desarrollado por un equipo pequeño. Si te resulta útil, puedes apoyar su desarrollo con una donación única de cualquier importe. Es un regalo — no cambia tu plan ni desbloquea ninguna función.",
  "settings.donateSuccessBody": "Tu donación ayuda a mantener SmartMixin en funcionamiento y a mejorarlo. Te lo agradecemos de verdad.",
  "settings.donateSuccessTitle": "¡Gracias por tu apoyo!",
  "settings.donateTitle": "Apoya a SmartMixin",
  "settings.dragToReorder": "Arrastra para reordenar",
  "settings.dutch": "holandés",
  "settings.english": "inglés",
  "settings.french": "francés",
  "settings.german": "alemán",
  "settings.gestures": "Gestos",
  "settings.greek": "griego",
  "settings.hungarian": "húngaro",
  "settings.italian": "italiano",
  "settings.japanese": "japonés",
  "settings.korean": "coreano",
  "settings.language": "Idioma",
  "settings.languageDescription": "Idioma preferido",
  "settings.light": "Tema claro",
  "settings.measurementUnits": "Unidades de medida",
  "settings.netatmoDashboard": "Panel de Netatmo",
  "settings.netatmoLayoutCards": "Lista de tarjetas",
  "settings.netatmoLayoutCardsDescription": "Una tarjeta por módulo, todo en un desplazamiento",
  "settings.netatmoLayoutClassic": "Clásico",
  "settings.netatmoLayoutClassicDescription": "Dos tarjetas, desliza entre módulos",
  "settings.netatmoNewLayoutNotice": "Nuevo diseño del panel: una tarjeta por módulo.",
  "settings.netatmoSwitchBackToClassic": "Volver al clásico",
  "settings.netatmoSwitchToLayout": "Cambiar a {layout}",
  "settings.norwegian": "noruego",
  "settings.notificationsSection": "Notificaciones",
  "settings.ongoingNotificationEnabled": "Activar notificación permanente",
  "settings.ongoingNotificationMetrics": "Métricas mostradas",
  "settings.ongoingNotificationPermissionRequired": "Se requiere permiso de notificación",
  "settings.ongoingNotificationPreviewHint": "Vista previa: activa el widget para mostrarlo",
  "settings.ongoingNotificationStatusBar": "Barra de estado",
  "settings.polish": "polaco",
  "settings.portuguese": "portugués",
  "settings.preferencesSection": "Preferencias",
  "settings.privacyPolicy": "Política de privacidad",
  "settings.russian": "ruso",
  "settings.serbian": "serbio",
  "settings.settings": "Configuración",
  "settings.settingsPageTitle": "Configuración - {page}",
  "settings.slovak": "eslovaco",
  "settings.smallDecimals": "Decimales pequeños",
  "settings.smallDecimalsDescription": "Mostrar dígitos decimales en un tamaño más pequeño",
  "settings.spanish": "español",
  "settings.statusBarWidget": "Widget de barra de estado",
  "settings.statusBarWidgetDescription": "Datos meteorológicos siempre visibles",
  "settings.subscriptionSection": "Suscripción",
  "settings.supportSection": "Soporte",
  "settings.swedish": "sueco",
  "settings.systemTheme": "Tema del sistema",
  "settings.termsOfService": "Términos de servicio",
  "settings.themeDarkShort": "Oscuro",
  "settings.themeLightShort": "Claro",
  "settings.themeSystemShort": "Sistema",
  "settings.turkish": "turco",
  "settings.ukrainian": "ucranio",
  "settings.units": "Unidades",
  "settings.unitsDescription": "Unidades de medida mostradas dentro de la aplicación",
  "settings.update": "Actualizar",
  "settings.windDirectionConvention": "Flecha de dirección del viento",
  "settings.windDirectionConventionDescription": "Elige cómo se muestran las flechas de dirección del viento",
  "settings.windDirectionMeteorological": "Dirección de origen",
  "settings.windDirectionMeteorologicalDescription": "La flecha indica de dónde viene el viento (convención meteorológica)",
  "settings.windDirectionOceanographic": "Dirección de flujo",
  "settings.windDirectionOceanographicDescription": "La flecha indica hacia dónde sopla el viento (convención oceanográfica)",
  "stations.addAStation": "Agregar una estación",
  "stations.addToFavorites": "Agregar a los favoritos",
  "stations.addYourOwnStation": "Agrega tu propia estación",
  "stations.clearRecentLocations": "Borrar todo",
  "stations.clearSearch": "Borrar búsqueda",
  "stations.currentLocation": "Ubicación actual",
  "stations.customizedStationName": "Nombre personalizado de la estación",
  "stations.favoriteLocations": "Favoritos",
  "stations.favoriteLocationsEmpty": "Puedes agregar hasta 5 ubicaciones favoritas.",
  "stations.favoriteStations": "Estaciones favoritas",
  "stations.filterStationDescription": "No muestres estaciones con medidas poco confiables",
  "stations.filterStations": "Filtrar estaciones",
  "stations.filterStationSourceDescription": "Selecciona los proveedores de estaciones que deseas mostrar en el mapa",
  "stations.findStationsNearYou": "Encontrar estaciones cerca de ti",
  "stations.hiddenStations": "Estaciones ocultas",
  "stations.hiddenStationsDescription": "Puedes mostrar una estación tocando el ícono del ojo situado a su lado.",
  "stations.hideStationNamed": "Ocultar {station}",
  "stations.lastSeen": "visto {time}",
  "stations.loadingStation": "Cargando estación…",
  "stations.location": "Ubicación",
  "stations.locationAddedToFavorites": "Ubicación agregada a favoritos",
  "stations.locationNotGranted": "El permiso de ubicación no se otorga. Permite el acceso a tu ubicación en la configuración del dispositivo.",
  "stations.locationRemovedFromFavorites": "Ubicación eliminada de favoritos",
  "stations.locations": "Ubicaciones",
  "stations.locationUnavailable": "No se pudo obtener tu ubicación. Revisa la configuración del dispositivo.",
  "stations.maxFavoriteLocationsReached": "Solo puedes tener hasta 5 ubicaciones favoritas. Quita una para agregar otra.",
  "stations.modifyFavoriteStations": "Modificar las estaciones favoritas",
  "stations.modifyFavoriteStationsDescription": "Puedes reordenar tus estaciones favoritas arrastrándolas. También puedes eliminarlas de la lista.",
  "stations.myLocation": "Mi ubicación",
  "stations.nearbyWeatherStations": "Estaciones meteorológicas cercanas",
  "stations.noLocationsFound": "No se encontraron ubicaciones",
  "stations.noLongerReported": "Ya no figura en la cuenta",
  "stations.noLongerReportedBy": "Ya no figura en {provider} desde el {date}",
  "stations.noSearchResults": "Ningún artículo coincide con tu búsqueda",
  "stations.noStationsFound": "No se encontraron estaciones",
  "stations.noWeatherStationYet": "No tienes una estación meteorológica.",
  "stations.recentLocations": "Recientes",
  "stations.recentLocationsEmpty": "Tu historial reciente está vacío.",
  "stations.removeFromFavorites": "Quitar de favoritos",
  "stations.removeStationNamed": "Quitar {station} de favoritos",
  "stations.reorderStationNamed": "Mover {station}",
  "stations.searchForLocation": "Buscar una ubicación",
  "stations.searchForWeatherStation": "Buscar una estación meteorológica",
  "stations.searchResults": "Resultados de la búsqueda",
  "stations.searchResultsEmpty": "No se encontraron resultados.",
  "stations.searchResultsFound": "{count, plural, one {# resultado encontrado} other {# resultados encontrados}}",
  "stations.searchStationsDescription": "Ingresa una ciudad, dirección o nombre de lugar para encontrar estaciones meteorológicas cercanas.",
  "stations.searchStationsHint": "Usa la barra de búsqueda de arriba para descubrir estaciones meteorológicas en cualquier lugar del mundo.",
  "stations.selectStationForComparison": "Selecciona una estación para comparar",
  "stations.stationAddedToFavorites": "Estación añadida a favoritos",
  "stations.stationCount": "{count, plural, one {# estación} other {# estaciones}}",
  "stations.stationInformation": "Información de la estación",
  "stations.stationName": "Nombre de la estación",
  "stations.stationObservationsDescription": "Mostrar las últimas observaciones de las estaciones meteorológicas.",
  "stations.stationRemovedFromFavorites": "Estación eliminada de favoritos",
  "stations.stationsLoading": "Cargando las estaciones meteorológicas",
  "stations.stationsNear": "Estaciones cerca de {place}",
  "stations.stationType": "Tipo de estación",
  "stations.statusOffline": "Sin conexión",
  "stations.statusOnline": "En línea",
  "stations.statusStale": "Desactualizado",
  "stations.tryAnotherLocation": "No pudimos encontrar estaciones meteorológicas cerca de esta ubicación. Intenta buscar en otra zona.",
  "stations.unhideStationNamed": "Volver a mostrar {station}",
  "stations.weatherStation": "Estación meteorológica",
  "stations.weatherStationCount": "{count, plural, one {# estación meteorológica} other {# estaciones meteorológicas}}",
  "stations.weatherStations": "Estaciones meteorológicas",
  "stations.welcomeConnectService": "¿Tienes una estación meteorológica? Conecta tu servicio",
  "stations.welcomeSubtitle": "Tu clima, todo en un solo lugar",
  "thermostat.away": "Ausente",
  "thermostat.boilerOn": "Calentador encendido",
  "thermostat.hg": "Protección antiheladas",
  "thermostat.homeInformation": "Información de la casa",
  "thermostat.homeName": "Nombre de la casa",
  "thermostat.manualBoost": "Impulso manual",
  "thermostat.manualSetpointUntil": "Consigna manual hasta",
  "thermostat.noThermostatYet": "No tienes un termostato Netatmo",
  "thermostat.relay": "Relé",
  "thermostat.room": "Habitación",
  "thermostat.rooms": "Habitaciones",
  "thermostat.smartThermostat": "Termostato inteligente",
  "thermostat.smartValve": "Válvula inteligente",
  "thermostat.whenBackHome": "¿Cuándo volverás a casa?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Pulgadas",
  "units.inchOfMercury": "Pulgadas de mercurio",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilómetros por hora",
  "units.knot": "Nudos",
  "units.meterPerSecond": "Metros por segundo",
  "units.milePerHour": "Millas por hora",
  "units.millibar": "Milibares",
  "units.millimeter": "Milímetros",
  "units.millimeterOfMercury": "Milímetros de mercurio",
  "weatherConditions.blizzard": "Ventisca",
  "weatherConditions.blowingDust": "Polvo levantado por el viento",
  "weatherConditions.blowingSnow": "Nieve levantada por el viento",
  "weatherConditions.breezy": "Brisa",
  "weatherConditions.clear": "Despejado",
  "weatherConditions.cloudy": "Nublado",
  "weatherConditions.drizzle": "Llovizna",
  "weatherConditions.flurries": "Nevada ligera",
  "weatherConditions.foggy": "Niebla",
  "weatherConditions.freezingDrizzle": "Llovizna helada",
  "weatherConditions.freezingRain": "Lluvia helada",
  "weatherConditions.frigid": "Frío glacial",
  "weatherConditions.hail": "Granizo",
  "weatherConditions.haze": "Calima",
  "weatherConditions.heavyRain": "Lluvia intensa",
  "weatherConditions.heavySnow": "Nevada intensa",
  "weatherConditions.hot": "Calor",
  "weatherConditions.hurricane": "Huracán",
  "weatherConditions.isolatedThunderstorms": "Tormentas aisladas",
  "weatherConditions.mixedRainAndHail": "Lluvia y granizo",
  "weatherConditions.mostlyClear": "Mayormente despejado",
  "weatherConditions.mostlyCloudy": "Mayormente nublado",
  "weatherConditions.mostlySunny": "Mayormente soleado",
  "weatherConditions.notAvailable": "Condiciones meteorológicas no disponibles",
  "weatherConditions.partlyCloudy": "Parcialmente nublado",
  "weatherConditions.rain": "Lluvia",
  "weatherConditions.rainSleet": "Lluvia y hielo granulado",
  "weatherConditions.rainSnow": "Lluvia y nieve",
  "weatherConditions.scatteredShowers": "Chubascos dispersos",
  "weatherConditions.scatteredSnowShowers": "Chubascos de nieve dispersos",
  "weatherConditions.scatteredThunderstorms": "Tormentas dispersas",
  "weatherConditions.showers": "Chubascos",
  "weatherConditions.sleet": "Hielo granulado",
  "weatherConditions.smoke": "Humo",
  "weatherConditions.snow": "Nieve",
  "weatherConditions.snowShowers": "Chubascos de nieve",
  "weatherConditions.strongStorms": "Tormentas fuertes",
  "weatherConditions.sunny": "Soleado",
  "weatherConditions.thunderstorms": "Tormentas",
  "weatherConditions.tornado": "Tornado",
  "weatherConditions.tropicalStorm": "Tormenta tropical",
  "weatherConditions.windy": "Ventoso",
  "weatherConditions.wintryMix": "Precipitación invernal mixta",
  "weatherMap.clusterMarkerName": "{metric} {value}, mediana de {count, plural, one {# estación} other {# estaciones}}, acercar",
  "weatherMap.legendHeavy": "Fuerte",
  "weatherMap.legendLight": "Ligera",
  "weatherMap.legendLightningHelp": "El color muestra la antigüedad de cada rayo en los últimos {minutes} minutos: los más recientes en blanco y los más antiguos en rojo oscuro.",
  "weatherMap.legendNewest": "Más recientes",
  "weatherMap.legendOldest": "Más antiguos",
  "weatherMap.legendStationsHelp": "El color del marcador refleja el valor de la métrica seleccionada.",
  "weatherMap.lightningDataAttribution": "Datos de rayos: Blitzortung.org",
  "weatherMap.lightningStrikes": "Rayos",
  "weatherMap.lightningStrikesDescription": "Mostrar rayos en tiempo real en el mapa",
  "weatherMap.mapLayers": "Capas del mapa",
  "weatherMap.mapLegend": "Leyenda del mapa",
  "weatherMap.mapMode": "Modo del mapa",
  "weatherMap.mapNameForecast": "Mapa de pronóstico, {model}, {variable}",
  "weatherMap.mapNameObservations": "Mapa meteorológico, observaciones",
  "weatherMap.modeForecast": "Pronóstico",
  "weatherMap.modeObservations": "Observaciones",
  "weatherMap.radarDataAttribution": "Datos de radar: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Hora del radar",
  "weatherMap.rainRadar": "Radar de lluvia",
  "weatherMap.rainRadarDescription": "Mostrar superposición de radar de lluvia en el mapa",
  "weatherMap.resetBearing": "Arrastra para girar el mapa, haz clic para volver a orientarlo al norte",
  "weatherMap.showingForecast": "Mostrando pronóstico: {model}, {variable}",
  "weatherMap.signInForecastBody": "Los mapas GFS son gratis con una cuenta de SmartMixin. Con Premium tienes acceso a más modelos.",
  "weatherMap.signInForecastTitle": "Inicia sesión para ver los mapas de pronóstico",
  "weatherMap.stationMarkerName": "{metric} {value}, una estación",
  "weatherMap.stationMarkersHint": "Las teclas de flecha pasan de una estación a otra",
  "weatherMap.stationMarkerWindValue": "{speed}, del {direction}",
  "weatherMap.weatherflowNCRain": "NC rain (Nearcast rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain es una fuente de datos adicional proporcionada a través del Tempest Weather System, impulsado por Nearcast Technology. Los datos de NC Rain son una estimación de la acumulación promedio de lluvia alrededor de tu Tempest a nivel de vecindario.",
  "weatherMap.weatherMap": "Mapa meteorológico",
  "weatherMap.weatherMapMetaDescription": "SmartMixin ofrece mapas meteorológicos interactivos y radares de lluvia para las condiciones climáticas en todo el mundo.",
  "weatherMap.zoomIn": "Acercar",
  "weatherMap.zoomOut": "Alejar",
  "weatherWarnings.activeNow": "Activos ahora",
  "weatherWarnings.agencyMessage": "Mensaje del servicio meteorológico",
  "weatherWarnings.areaCovered": "Zona afectada",
  "weatherWarnings.areaThisLocation": "{area} (esta ubicación)",
  "weatherWarnings.areaYourStation": "{area} (tu estación meteorológica)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Aviso oficial, {severity}: {hazard}} one {Aviso oficial, {severity}: {hazard}, y # más} other {Aviso oficial, {severity}: {hazard}, y # más}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Aviso oficial próximo, {severity}: {hazard}} one {Aviso oficial próximo, {severity}: {hazard}, y # más} other {Aviso oficial próximo, {severity}: {hazard}, y # más}}",
  "weatherWarnings.crumb": "Avisos oficiales",
  "weatherWarnings.emptyBody": "El servicio meteorológico nacional no tiene ningún aviso en vigor para este lugar. Volvemos a comprobarlo cada pocos minutos.",
  "weatherWarnings.emptyTitle": "Sin avisos oficiales",
  "weatherWarnings.ended": "Finalizado",
  "weatherWarnings.endedAt": "Este aviso finalizó {time}.",
  "weatherWarnings.errorBody": "Comprueba tu conexión. Lo volvemos a intentar cada pocos minutos.",
  "weatherWarnings.errorTitle": "No se pudieron cargar los avisos oficiales",
  "weatherWarnings.fromTime": "Desde {time}",
  "weatherWarnings.hazardAirQuality": "Calidad del aire",
  "weatherWarnings.hazardAvalanche": "Aludes",
  "weatherWarnings.hazardCoastalEvent": "Fenómenos costeros",
  "weatherWarnings.hazardFlood": "Inundaciones",
  "weatherWarnings.hazardFog": "Niebla",
  "weatherWarnings.hazardForestFire": "Incendios forestales",
  "weatherWarnings.hazardHighTemperature": "Temperaturas altas",
  "weatherWarnings.hazardLowTemperature": "Temperaturas bajas",
  "weatherWarnings.hazardOther": "Otro peligro",
  "weatherWarnings.hazardRain": "Lluvia",
  "weatherWarnings.hazardSnowIce": "Nieve y hielo",
  "weatherWarnings.hazardThunderstorm": "Tormentas",
  "weatherWarnings.hazardUv": "Radiación UV",
  "weatherWarnings.hazardWind": "Viento",
  "weatherWarnings.hideHazards": "Ocultar fenómenos",
  "weatherWarnings.issuedBy": "Emitido por {sender}",
  "weatherWarnings.lastUpdate": "Última actualización: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Mapa de la zona afectada: {area}.} other {Mapa de las # zonas afectadas. {area} está resaltada.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Mapa de la zona afectada.} other {Mapa de las # zonas afectadas.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Mapa no disponible. La zona aparece abajo.} other {Mapa no disponible. Las # zonas aparecen abajo.}}",
  "weatherWarnings.moreHazards": "+ {count} más: {hazards}",
  "weatherWarnings.notInLanguage": "No disponible en {language}. Se muestra tal como lo publicó el servicio meteorológico.",
  "weatherWarnings.openOn": "Abrir en {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # zona más} other {+ # zonas más}}",
  "weatherWarnings.severityExtreme": "Extremo",
  "weatherWarnings.severityFrom": "{severity} desde {time}",
  "weatherWarnings.severityMinor": "Leve",
  "weatherWarnings.severityModerate": "Moderado",
  "weatherWarnings.severityNow": "{severity} ahora",
  "weatherWarnings.severitySevere": "Grave",
  "weatherWarnings.severityUntil": "{severity} hasta {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Mostrar # zona} other {Mostrar las # zonas}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Mostrar # zona en el mapa} other {Mostrar las # zonas en el mapa}}",
  "weatherWarnings.showHazards": "Mostrar fenómenos",
  "weatherWarnings.showPeriods": "{count, plural, one {Mostrar # periodo} other {Mostrar los # periodos}}",
  "weatherWarnings.source": "Fuente: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, después {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# aviso meteorológico oficial} other {# avisos meteorológicos oficiales}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Avisos meteorológicos oficiales",
  "weatherWarnings.todayAt": "hoy a las {time}",
  "weatherWarnings.tomorrow": "Mañana",
  "weatherWarnings.tomorrowAt": "mañana a las {time}",
  "weatherWarnings.upcoming": "Próximos",
  "weatherWarnings.viewAll": "Todos los avisos oficiales",
  "weatherWarnings.whatToDo": "Qué hacer"
}
